// TODO spielendes Album-Cover nach Nachlade-Aktion wieder identifizieren und Audioplayer.cover/playbutton etc. Variablen zuweisen
// TODO bzw. drehendes Album-Cover stoppen falls man von anderer Seite zu gemerkter Trackliste zurückkommt

let     resizeTimer,
        scrollTimer,
        lang,
        AlbumViewer,
        myViewer,
        stdEventType = 'click';

const   base = '/',
        myScreen = {},
        myBrowser = {
            engine: '',
            version: 0,
            os: ''
        },
        ie11 = !!navigator.userAgent.match(/Trident\/7\.0/),
        edge = !!navigator.userAgent.match(/edge\//),
        aniType = ['linear', 'ease-in', 'ease-out', 'ease-in-out'];

if(!sessionStorage.getItem('tabSessionId'))
{
    sessionStorage.setItem('tabSessionId', Date.now().toString());
}

window.addEventListener('DOMContentLoaded',function()
{
    const currentUrl = document.location.pathname;
    Load.initialize();
    Load.push_url(currentUrl, document.title,true);

    // reset tab session
    if(document.body.dataset.onload === 'resetTabSession')
    {
        Load.do_request({f: 'resetTabSession'});
    }

    // get language from HTML
    lang = document.documentElement.lang;

    // get browser engine and version
    get_browser();

    // set body styles depending on browser config
    if((myBrowser.engine === 'gecko' && myBrowser.version >= 64) ||
       (myBrowser.engine === 'blink' && myBrowser.version >= 4) ||
       (myBrowser.engine === 'webkit' && myBrowser.version >= 5.1))
    {
        document.body.classList.add('w__thin-scrollbars');
    }

    if(myBrowser.engine === 'webkit')
    {
        document.body.classList.add('safari');
    }

    // add hover for non-touch os
    if(myBrowser.mobile === false)
    {
        document.body.classList.add('w__hover');
    }

    // get screensize
    get_screenSize();

    // initialize static classes
    Header.initialize();
    AlbumViewer = new Viewer('album');
    myViewer = new Viewer('');

    // in case of existing viewer, adopt it
    const existingViewer = document.body.querySelector('.w__viewer');
    if(existingViewer)
    {
        switch(existingViewer.dataset.mode)
        {
            case 'album':
                AlbumViewer.adopt_existingViewer(existingViewer);
                break;

            case 'clipboard':
                myViewer.adopt_existingViewer(existingViewer);
                break;

            case 'login':
                myViewer.adopt_existingViewer(existingViewer);
                break;
        }
    }

    // start slideshow
    if(Header.ready === true)
    {
        setTimeout(Header.change_image,2500);
    }

    // relayed events
    document.addEventListener(stdEventType,e =>
    {
        let el = e.target;

        if(el.classList && el.classList.contains('direct-download'))
        {
            const dlDiv = el.closest('.w__download--div');
            const myButton = el.closest('.w__track--cmd.download');
            if(dlDiv)
            {
                dlDiv.remove();
            }
            myButton.classList.remove('active');
            myButton.classList.add('downloaded');
            return false;
        }

        if((el.classList && !el.classList.contains('w__js-button') || !el.classList) &&
            el.closest('.w__js-button'))
        {
            el = el.closest('.w__js-button');
        }

        if(!el.classList.contains('inactive') && el.classList.contains('w__js-button') && el.dataset.f)
        {
            e.preventDefault();

            let allTracks,
                myData = {},
                trackIds = [],
                trackNotes = [];

            switch(el.dataset.f)
            {
                case 'album':
                    if(!myViewer.active &&
                       el.dataset.albumId &&
                       el.dataset.albumCode)
                    {
                        AlbumViewer.start({albumId: el.dataset.albumId, albumCode: el.dataset.albumCode});
                    }
                    break;

                case 'audio-close':
                    Audioplayer.stop();
                    break;

                case 'audio-play-pause':
                    Audioplayer.play_orPause(true);
                    break;

                case 'audio-next':
                    Audioplayer.play_next(true);
                    break;

                case 'audio-prev':
                    if(Audioplayer.player && Audioplayer.player.currentTime > 5)
                    {
                        Audioplayer.player.currentTime = 0;
                        Audioplayer.update_needle();
                    }
                    else
                    {
                        Audioplayer.play_previous();
                    }
                    break;

                case 'audio-start':
                    Audioplayer.start(el);
                    break;

                case 'audio-relay':
                    Audioplayer.start(el.closest('li').querySelector('.w__track--cmd.play'));
                    break;

                case 'audio-seek':
                    Audioplayer.seek(e);
                    break;

                case 'clipboard':
                    switch(el.dataset.action)
                    {
                        case 'add-track':
                            if(!el.classList.contains('selected'))
                            {
                                const noteText = el.closest('.w__track').querySelector('.w__track--description-note-text');

                                Load.do_request({f: 'clipboard',
                                                         trackId: el.dataset.trackId,
                                                         trackNote: noteText ? noteText.textContent : '',
                                                         action: el.dataset.action},
                                    false,
                                               el);
                            }
                            break;

                        case 'add-album':
                            allTracks = AlbumViewer.container.querySelectorAll('.w__track--cmd.clipboard:not(.selected)');
                            for(let i=0; i<allTracks.length; i++)
                            {
                                trackIds[trackIds.length] = allTracks[i].dataset.trackId;
                            }
                            if(trackIds.length > 0)
                            {
                                Load.do_request({f: 'clipboard', trackIds: trackIds, action: el.dataset.action},false, el);
                            }
                            break;

                        case 'add-playlist':
                            allTracks = myViewer.container.querySelectorAll('.w__track--cmd.clipboard:not(.selected)');
                            for(let i=0; i<allTracks.length; i++)
                            {
                                trackIds[trackIds.length] = allTracks[i].dataset.trackId;
                                trackNotes[trackNotes.length] = allTracks[i].closest('.w__track')
                                                                            .querySelector('.w__track--description-note-text')
                                                                    ? allTracks[i].closest('.w__track')
                                                                                  .querySelector('.w__track--description-note-text')
                                                                                  .textContent
                                                                    : '';
                            }
                            if(trackIds.length > 0)
                            {
                                Load.do_request({f: 'clipboard', trackIds: trackIds, trackNotes: trackNotes, action: el.dataset.action},
                                                false,
                                                 el);
                            }
                            break;

                        case 'cancel':
                            myViewer.reset_clipboardSave();
                            break;

                        case 'del-track':
                        case 'show-save-form':
                            if(!el.classList.contains('active'))
                            {
                                myData = {action: el.dataset.action};

                                if(myViewer.playlist_isActive())
                                {
                                    myData.f = 'playlist';
                                    myData.playlistId = myViewer.playlistId;
                                    myData.playlistHash = myViewer.playlistHash;
                                }
                                else
                                {
                                    myData.f = 'clipboard';
                                }

                                // special cases
                                if(el.dataset.action === 'del-track')
                                {
                                    myData.trackId = el.dataset.trackId;
                                }
                                else if(el.dataset.action === 'show-save-form')
                                {
                                    el.classList.add('active');
                                }

                                Load.do_request(myData,false, el);
                            }
                            break;

                        case 'reset':
                            let emptyConfirm;
                            if(el.classList.contains('w__confirm--cancel'))
                            {
                                el.closest('.w__icon--cmd').classList.remove('active');
                                el.closest('.w__download--div').remove();
                            }
                            else if(el.classList.contains('active'))
                            {
                                emptyConfirm = el.querySelector('.w__download--div');
                                if(emptyConfirm)
                                {
                                    emptyConfirm.remove();
                                }
                                el.classList.remove('active');
                            }
                            else
                            {
                                emptyConfirm = create('div', {className: 'w__download--div'});
                                const delNo = create('span',
                                    {
                                        className: 'w__js-button w__download--button w__confirm--cancel',
                                        text: (lang === 'de') ? 'Nein' : 'No',
                                        dataset: {
                                            f: 'clipboard',
                                            action: 'reset'
                                        }
                                    }),
                                    delYes = create('span',
                                        {
                                            className: 'w__js-button w__download--button',
                                            text: (lang === 'de') ? 'Ja' : 'Yes',
                                            dataset: {
                                                f: 'clipboard',
                                                action: 'reset-confirmed',
                                                playlistId: myViewer.playlistId,
                                                playlistHash: myViewer.playlistHash
                                            }
                                        });
                                emptyConfirm.appendChild(delNo);
                                emptyConfirm.appendChild(delYes);
                                el.classList.add('active');
                                el.appendChild(emptyConfirm);
                            }
                            break;

                        case 'reset-confirmed':
                            // remove confirmation buttons
                            el.closest('.w__icon--cmd').classList.remove('active');
                            const tempParent = el.closest('.w__download--div');
                            if(tempParent)
                            {
                                tempParent.remove();
                            }

                            myData = {action: 'reset'};
                            if(myViewer.playlist_isActive())
                            {
                                myData.f = 'playlist';
                                myData.playlistId = myViewer.playlistId;
                                myData.playlistHash = myViewer.playlistHash;
                            }
                            else
                            {
                                myData.f = 'clipboard';
                            }
                            Load.do_request(myData,false, el);
                            break;

                        default:
                            set_mobileMenu(true);
                            Load.do_request({f: 'clipboard', trackId: el.dataset.trackId, action: el.dataset.action});
                    }
                    break;

                case 'copy':
                    const dataEl = el.closest('.w__track--info').querySelector('.w__track--info-ul.copy');
                    if(dataEl)
                    {
                        el.classList.add('active');
                        const tempInput = document.createElement('textarea');
                        document.body.appendChild(tempInput);
                        tempInput.textContent = dataEl.textContent;
                        tempInput.select();
                        document.execCommand('copy');
                        tempInput.remove();
                        setTimeout(() =>
                        {
                            el.classList.remove('active');
                        }, 500);
                    }
                    break;

                case "download":
                    if(el.classList && el.classList.contains('active'))
                    {
                        el.classList.remove('active');
                        const dlDiv = el.querySelector('.w__download--div');
                        if(dlDiv)
                        {
                            dlDiv.remove();
                        }
                    }
                    else
                    {
                        Load.do_request({f: 'download', trackId: el.dataset.trackId}, false, el);
                    }
                    break;

                case "download-info":
                    Load.do_request({f: 'download-info', type: el.dataset.type, trackId: el.dataset.trackId});
                    break;

                case 'filter-add':
                    Filter.add_filter(el);
                    break;

                case 'filter-category-remove':
                    Filter.remove_category(el.closest('.w__filter--main'),true);
                    break;

                case 'filter-category-remove-no-ani':
                    el.closest('.w__filter--main').remove();
                    Filter.update_search();
                    break;

                case 'filter-duration-add':
                    Filter.add_duration(el.closest('.w__filter--duration').querySelector('.w__input--duration'));
                    break;

                case 'filter-info-add':
                    Filter.add_info_filter(el);
                    break;

                case 'filter-remove':
                    Filter.remove_filter(el,true);
                    break;

                case 'filter-remove-no-ani':
                    const elCategory = el.closest('.w__filter--main');
                    el.remove();
                    if(elCategory.querySelectorAll('.w__filter--option').length === 0)
                    {
                        elCategory.remove();
                    }
                    Filter.update_search();
                    break;

                case 'info':
                    el.classList.toggle('active');
                    const myTrack = el.closest('.w__track');
                    if(el.classList && el.classList.contains('active'))
                    {
                        const viewerActive = (AlbumViewer.active === true ||
                                              myViewer.active === true);

                        Load.do_request({
                            f:'trackinfo',
                            trackId: el.dataset.trackId,
                            viewer: viewerActive,
                            url: document.location.pathname
                        },false, el);
                        myTrack.classList.add('w__track--with-info');
                    }
                    else
                    {
                        const trackInfo = el.closest('.w__track').querySelector('.w__track--info');
                        if(trackInfo)
                        {
                            trackInfo.remove();
                        }
                        myTrack.classList.remove('w__track--with-info');
                        Audioplayer.update_coverPosition();
                        if(AlbumViewer.active)
                        {
                            AlbumViewer.adjustView_album(false);
                        }
                        else if(myViewer.active && myViewer.mode === 'clipboard')
                        {
                            myViewer.adjustView_clipboard();
                        }
                    }

                    break;

                case 'qsearch':
                    Load.do_request({f: 'nav', url: Load.get_menuHref('find-music'), reset: true},
                        false,
                        {word: el.parentElement.querySelector('.w__input').trim()});
                    break;

                case 'qfilter':
                    const filterTable = el.closest('.w__quickfilter').dataset.filterTable,
                          filterCategoryId = el.closest('.w__quickfilter').dataset.filterCategoryId,
                          filterId = el.dataset.filterId;
                    Load.do_request({f: 'nav', url: Load.get_menuHref('find-music'), reset: true},
                                    false,
                                    {filter: {table: filterTable, categoryId: filterCategoryId, filterId: filterId}});
                    break;

                case 'location':
                    get_location(el);
                    break;

                case 'login':
                case 'logout':
                case 'profile':
                    set_mobileMenu(true);
                    Load.do_request({f: el.dataset.f});
                    break;

                case 'mobile-toggle-order':
                    if(window.matchMedia('(max-width: 715px)').matches)
                    {
                        let myOrderNo = el.dataset.selection ? parseInt(el.dataset.selection) : 0;
                        const myOrders = [
                            {
                                field: 'date',
                                direction: 'desc'
                            },
                            {
                                field: 'date',
                                direction: 'asc'
                            },
                            {
                                field: 'title',
                                direction: 'desc'
                            },
                            {
                                field: 'title',
                                direction: 'asc'
                            }
                        ];
                        myOrderNo++;
                        if(myOrderNo >= myOrders.length)
                        {
                            myOrderNo = 0;
                        }
                        el.dataset.selection = myOrderNo.toString();

                        el.closest('.w__icon--cmd').querySelector('.w__icon--icon').src = base + 'pix/icon_sort-' +
                            myOrders[myOrderNo]['field'] + '-' + myOrders[myOrderNo]['direction'] + '.svg';

                        // make sure Filter has been initialized
                        Filter.initialize();

                        // call search
                        Filter.order = {
                            field: myOrders[myOrderNo]['field'],
                            direction: myOrders[myOrderNo]['direction']
                        };
                        Filter.update_search();
                    }
                    break;

                case 'mobile-toggle-view':
                    if(window.matchMedia('(max-width: 715px)').matches)
                    {
                        let myViewNo = el.dataset.selection ? parseInt(el.dataset.selection) : 0;
                        const myViews = [
                            {
                                class: 'view--details',
                                svg: 'view-details.svg'
                            },
                            {
                                class: 'view--albums',
                                svg: 'view-albums.svg'
                            }
                        ];
                        myViewNo++;
                        if(myViewNo >= myViews.length)
                        {
                            myViewNo = 0;
                        }
                        el.dataset.selection = myViewNo.toString();

                        el.closest('.w__icon--cmd').querySelector('.w__icon--icon').src = base + 'pix/icon_' + myViews[myViewNo]['svg'];

                        document.body.classList.remove('w__view--compact');
                        document.body.classList.remove('w__view--details');
                        document.body.classList.remove('w__view--albums');
                        document.body.classList.add('w__' + myViews[myViewNo]['class']);
                        document.body.dataset.viewClass = myViews[myViewNo]['class'];
                        Audioplayer.update_coverPosition();
                        do_onScroll();
                    }
                    break;

                case 'nav':
                    if(!(el.classList.contains('w__module--hover') &&
                         myBrowser.mobile === true))
                    {
                        set_mobileMenu(true);
                        const myUrl = el.dataset.href ? el.dataset.href : el.getAttribute('href');
                        Load.do_request({f: el.dataset.f, url: myUrl, navFunction: el.dataset.function});
                    }
                    break;

                case 'playlist':
                    let doLoad = false;
                    if(el.classList.contains('w__playlist--item'))
                    {
                        if(!(el.classList.contains('active') ||
                             el.classList.contains('viewed')))
                        {
                            doLoad = true;
                        }
                    }
                    else
                    {
                        switch(el.dataset.action)
                        {
                            case 'close':
                                const viewedTrack = myViewer.playlistAvailable.querySelector('.w__playlist--item.viewed');
                                if(viewedTrack)
                                {
                                    viewedTrack.classList.remove('viewed');
                                }
                                myViewer.playlist_switch('clipboard');
                                myViewer.clipboardTracks.innerHTML = '';
                                doLoad = true;
                                break;

                            case 'delete':
                                let delConfirm;
                                if(el.classList.contains('w__confirm--cancel'))
                                {
                                    el.closest('.w__icon--cmd').classList.remove('active');
                                    el.closest('.w__download--div').remove();
                                }
                                else if(el.classList.contains('active'))
                                {
                                    delConfirm = el.querySelector('.w__download--div');
                                    if(delConfirm)
                                    {
                                        delConfirm.remove();
                                    }
                                    el.classList.remove('active');
                                }
                                else
                                {
                                    delConfirm = create('div', {className: 'w__download--div'});
                                    const delNo = create('span',
                                            {
                                                className: 'w__js-button w__download--button w__confirm--cancel',
                                                text: (lang === 'de') ? 'Nein' : 'No',
                                                dataset: {
                                                    f: 'playlist',
                                                    action: 'delete'
                                                }
                                            }),
                                        delYes = create('span',
                                            {
                                                className: 'w__js-button w__download--button',
                                                text: (lang === 'de') ? 'Ja' : 'Yes',
                                                dataset: {
                                                    f: 'playlist',
                                                    action: 'delete-confirmed',
                                                    playlistId: myViewer.playlistId,
                                                    playlistHash: myViewer.playlistHash
                                                }
                                            });
                                    delConfirm.appendChild(delNo);
                                    delConfirm.appendChild(delYes);
                                    el.classList.add('active');
                                    el.appendChild(delConfirm);
                                }
                                break;

                            case 'delete-confirmed':
                            case 'edit':
                                doLoad = true;
                                break;

                            case 'share':
                                const shareUrl = window.location.protocol + '//' + window.location.hostname + base +
                                                 lang + '/playlist/' + myViewer.playlistId + '/' +
                                                 myViewer.playlistHash,
                                      shareText =  el.dataset['shareText'].replace('{PLAYLIST_LINK}',
                                                            '<a href="' + shareUrl + '" ' +
                                                            'class="w__link w__break" target="_blank">' +
                                                             shareUrl + '</a>');
                                Load.show_notice(shareText,'w__notice--download', el);
                                const tempInput = document.createElement('textarea');
                                document.body.appendChild(tempInput);
                                tempInput.textContent = shareUrl;
                                tempInput.select();
                                document.execCommand('copy');
                                tempInput.remove();
                                break;

                            case 'view':
                                myViewer.mode = 'playlist';
                                myViewer.start({playlistId: el.dataset.playlistId,
                                                   playlistHash: el.dataset.playlistHash});
                                break;
                        }
                    }

                    if(doLoad === true)
                    {
                        Load.do_request({
                            f: el.dataset.f,
                            action: el.dataset.action,
                            playlistId: el.dataset.playlistId,
                            playlistHash: el.dataset.playlistHash
                        },false, el);
                    }
                    break;

                case 'reset-login':
                    Load.do_request({f: 'load-form', type: 'reset-login'},false, el);
                    break;

                case 'reset-pw':
                    Load.do_request({f: 'load-form', type: 'reset-pw'},false, el);
                    break;

                case 'search':
                    Filter.add_word(el.parentElement.querySelector('.w__input'));
                    break;

                case 'toggle-li-active':
                    Filter.toggle_category(el.closest('li'));
                    break;

                case 'toggle-filter':
                    if(el.classList.contains('w__search-bar--track-count'))
                    {
                        el = document.getElementById('w--search-bar').querySelector('.w__mobile--toggle-filter');
                    }

                    if(el)
                    {
                        el.classList.toggle('active');
                    }

                    const myFilters = document.getElementById('w--search-bar').querySelector('.w__search-bar--filter-div');
                    if(myFilters)
                    {
                        myFilters.classList.toggle('active');
                    }
                    break;

                case 'toggle-mobile-menu':
                    set_mobileMenu(el.classList.contains('active'));
                    break;

                case 'toggle-order':
                    el.closest('.w__icon--cmd').querySelector('.w__icon--icon').src = el.querySelector('.w__search-bar--options-icon').src;

                    // make sure Filter has been initialized
                    Filter.initialize();

                    // only call search if order has changed
                    if(Filter.order.field !== el.dataset.field ||
                        Filter.order.direction !== el.dataset.direction)
                    {
                        Filter.order = {
                            field: el.dataset.field,
                            direction: el.dataset.direction
                        };
                        Filter.update_search();
                    }
                    break;

                case 'toggle-variant':
                    el.classList.toggle('active');

                    if(AlbumViewer.active === true)
                    {
                        if(el.classList && el.classList.contains('active'))
                        {
                            AlbumViewer.container.classList.add('w__viewer--with-variants');
                            AlbumViewer.trackVariants = true;
                        }
                        else
                        {
                            AlbumViewer.container.classList.remove('w__viewer--with-variants');
                            AlbumViewer.trackVariants = false;
                            if(!Audioplayer.playButton.closest('.w__track.main'))
                            {
                                Audioplayer.stop();
                            }
                        }
                    }
                    else
                    {
                        el.closest('.w__track').querySelector('.w__track--variant-ul').classList.toggle('active');
                    }
                    Audioplayer.update_coverPosition();
                    //Audioplayer.update_scrollPosition();
                    do_onScroll();
                    break;

                case 'toggle-view':
                    el.closest('.w__icon--cmd').querySelector('.w__icon--icon').src = el.querySelector('.w__search-bar--options-icon').src;
                    document.body.classList.remove('w__view--compact');
                    document.body.classList.remove('w__view--details');
                    document.body.classList.remove('w__view--albums');
                    document.body.classList.add('w__' + el.dataset['class']);
                    document.body.dataset.viewClass = el.dataset['class'];
                    Audioplayer.update_coverPosition();
                    do_onScroll();
                    break;

                case 'toggle-waveform':
                    el.classList.toggle('active');
                    if(AlbumViewer.active === true)
                    {
                        AlbumViewer.container.classList.toggle('w__tracks--show-wav');
                        AlbumViewer.container.offsetHeight;
                    }
                    else if(myViewer.active === true && myViewer.mode === 'clipboard')
                    {
                        myViewer.container.classList.toggle('w__tracks--show-wav');
                        myViewer.container.offsetHeight;
                    }
                    else
                    {
                        document.getElementById('w--tracks').classList.toggle('w__tracks--show-wav');
                        document.getElementById('w--tracks').offsetHeight;
                    }
                    Audioplayer.update_coverPosition();
                    Audioplayer.update_scrollPosition();
                    do_onScroll();
                    break;

                case 'zip':
                    if(el.dataset.type &&
                       el.dataset.filetype &&
                      (el.dataset.filetype === 'wav' ||
                       el.dataset.filetype === 'mp3'))
                    {
                        let downloadOk = false;

                        const parameters = {
                            f: 'zip',
                            type: el.dataset.type,
                            filetype: el.dataset.filetype
                        };

                        switch(el.dataset.type)
                        {
                            case 'album':
                            case 'track':
                                if(el.dataset.id)
                                {
                                    parameters.id = el.dataset.id;
                                    downloadOk = true;
                                }
                                if(el.dataset.type === 'track' &&
                                   el.closest('.w__download--div'))
                                {
                                    el.closest('.w__track--cmd.download').classList.remove('active');
                                    el.closest('.w__download--div').remove();
                                }
                                break;

                            case 'clipboard':
                                if(myViewer.playlist_isActive())
                                {
                                    parameters.type = 'playlist';
                                    parameters.id = myViewer.playlistId;
                                    parameters.hash = myViewer.playlistHash;
                                }
                                downloadOk = true;
                                break;

                            case 'playlist':
                                parameters.id = myViewer.playlistId;
                                parameters.hash = myViewer.playlistHash;
                                downloadOk = true;
                                break;
                        }

                        if(downloadOk === true)
                        {
                            Load.do_request(parameters,false, el);
                        }
                    }
                    break;

                default:
                    console.log("Undefined command: " + el.dataset.f, el);
            }
        }
        else if(myViewer.active === true &&
                el.closest('.w__viewer--form') &&
               (el.classList.contains('w__input--checkbox') ||
                el.classList.contains('w__input')))
        {
            myViewer.check_form(el.closest('.w__viewer--form'));
        }

    });

    document.body.addEventListener('focus',e =>
    {
        const el = e.target;

        if(el.classList && el.classList.contains('w__fulltext-search--input'))
        {
            el.closest('.w__fulltext-search--div').querySelector('.w__fulltext-search--placeholder').classList.add('none');
        }
    },true);

    document.body.addEventListener('blur',e =>
    {
        const el = e.target;

        if(el.classList && el.classList.contains('w__fulltext-search--input'))
        {
            if(!el.value.trim())
            {
                el.closest('.w__fulltext-search--div').querySelector('.w__fulltext-search--placeholder').classList.remove('none');
            }
        }
        else if(el.classList && el.classList.contains('w__track--description-note'))
        {
            el.scrollLeft = 0;
        }
    },true);

    document.body.addEventListener('keydown',e =>
    {
        const el = e.target;

        if(el)
        {
            if(e.key.toLowerCase() === 'enter')
            {
                if(el.classList && el.classList.contains('w__fulltext-search--input'))
                {
                    if(el.dataset.f === 'qsearch')
                    {
                        Load.do_request({f: 'nav', url: Load.get_menuHref('find-music')},
                            false,
                            {word: el.parentElement.querySelector('.w__input').value.trim()});
                    }
                    else
                    {
                        Filter.add_word(el);
                    }
                }
                else if(el.classList && el.classList.contains('w__input--duration'))
                {
                    Filter.add_duration(el);
                }
                else if(el.tagName.toLowerCase() !== 'input' &&
                        el.tagName.toLowerCase() !== 'textarea' &&
                        Audioplayer.playing === true &&
                        Audioplayer.audioId)
                {
                    let myPlayButton;
                    if(AlbumViewer.active === true)
                    {
                        myPlayButton = AlbumViewer.container.querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
                    }
                    else if(myViewer.active === true && myViewer.mode === 'clipboard')
                    {
                        myPlayButton = myViewer.container.querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
                    }
                    else
                    {
                        myPlayButton = document.body.querySelector('#w--tracks .w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
                    }
                    if(myPlayButton)
                    {
                        const myClipboardButton = myPlayButton.closest('.w__track')
                                                              .querySelector('.w__track--cmd.clipboard:not(.selected)');
                        if(myClipboardButton)
                        {
                            Load.do_request({f: 'clipboard', trackId: myClipboardButton.dataset.trackId, action: 'add-track'},
                                false,
                                           myClipboardButton);
                        }
                    }
                }
            }
            else if(el.tagName.toLowerCase() !== 'input' &&
                    el.tagName.toLowerCase() !== 'textarea')
            {
                const keyPressed = e.key.toLowerCase();

                switch(keyPressed)
                {
                    case 'arrowdown':
                    case 'down':
                        e.preventDefault();
                        Audioplayer.play_next(true);
                        break;

                    case 'arrowup':
                    case 'up':
                        e.preventDefault();
                        Audioplayer.play_previous(true);
                        break;

                    case 'arrowright':
                    case 'right':
                        e.preventDefault();
                        Audioplayer.seek(null, 10);
                        break;

                    case 'arrowleft':
                    case 'left':
                        e.preventDefault();
                        Audioplayer.seek(null, -10);
                        break;

                    case 'delete':
                    case 'del':
                        if(myViewer.active === true &&
                           myViewer.mode === 'clipboard' &&
                           Audioplayer.playing === true &&
                           Audioplayer.audioId)
                        {
                            const myButton = myViewer.container.querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]')
                                                               .closest('.w__track')
                                                               .querySelector('.w__track--cmd.delete');
                            Load.do_request({f: 'clipboard', trackId: myButton.dataset.trackId, action: 'del-track'}, false, myButton);
                        }
                        break;

                    case 'escape':
                    case 'esc':
                        if(AlbumViewer.active === true)
                        {
                            AlbumViewer.close();
                        }else
                        {
                            Audioplayer.stop();
                        }
                        break;

                    case 'spacebar':
                    case ' ':
                        e.preventDefault();
                        Audioplayer.play_orPause();
                        break;
                }
            }
            else if(el.classList && el.classList.contains('w__input') &&
                    el.closest('.w__viewer--form') && myViewer.active === true)
            {
                myViewer.check_form(el.closest('.w__viewer--form'));
            }
        }
    },true);

    document.body.addEventListener('submit', e =>
    {
        const el = e.target;

        if(!el.classList.contains('w__form-newsletter') &&
            myViewer.active === true)
        {
            e.preventDefault();
            if(el.dataset.f === 'clipboard' &&
               el.querySelector('.w__input[name="label"]').value.trim().length >= 2)
            {
                const myData = {
                    f: 'clipboard',
                    action: el.dataset.action,
                    data: {
                        name: el.querySelector('.w__input[name="label"]').value.trim(),
                        description: el.querySelector('.w__input[name="description"]').value.trim()
                    }
                };

                if(myViewer.playlist_isActive())
                {
                    myData.f = 'playlist';
                    myData.playlistId = myViewer.playlistId;
                    myData.playlistHash = myViewer.playlistHash;
                }

                else
                {
                    myData.data.keepClipboard = !!el.querySelector('.w__input[name="keep_clipboard"]').checked;
                }

                Load.do_request(myData);
            }
            else
            {
                myViewer.submit_form(el);
            }
        }
    });

    document.body.addEventListener('input', e =>
    {
        e.preventDefault();
        const el = e.target;
        if(el &&
           el.classList.contains('w__input'))
        {
            if(el.classList && el.classList.contains('w__input--save-on-change'))
            {
                if(this.autosaveTimeout)
                {
                    clearTimeout(this.autosaveTimeout);
                }
                this.autosaveTimeout = setTimeout(() =>
                {
                    const myData = {
                        f: 'clipboard',
                        action: 'save-on-change',
                        trackId: el.dataset.trackId,
                        fieldName: el.name,
                        value : el.value.trim()
                    };

                    if(myViewer.playlist_isActive())
                    {
                        myData.f = 'playlist';
                        myData.playlistId = myViewer.playlistId;
                        myData.playlistHash = myViewer.playlistHash;
                    }

                    Load.do_request(myData);
                }, 1000);
            }
            else if(el.closest('.w__viewer--form') &&
                    myViewer.active === true)
            {
                myViewer.check_form(el.closest('.w__viewer--form'));
            }
        }
    },true);


    document.body.addEventListener('mouseenter', e =>
    {
        const el = e.target;
        if(el &&
           el.classList &&
           el.classList.contains('w__image--fluid'))
        {
            const randomVar = [];
            for(let i=0; i<4; i++)
            {
                randomVar[i] = (get_randomInt(250) + 250).toString() + 'ms ' + aniType[get_randomInt(4)];
            }
            el.style.transition = 'border-top-left-radius ' + randomVar[0] + ', ' +
                                  'border-top-right-radius ' + randomVar[1] + ', ' +
                                  'border-bottom-right-radius ' + randomVar[2] + ', ' +
                                  'border-bottom-left-radius ' + randomVar[3] + ', ' +
                                  'filter 350ms ease-in-out';
            el.offsetHeight;
        }
    },true);

    if(myBrowser.mobile === true)
    {
        document.addEventListener('touchstart',e =>
        {
            let el = e.target;

            if(!el.classList.contains('w__search-bar--options') &&
               !el.classList.contains('w__menu--option') &&
                el.closest('.w__mobile--submenu'))
            {
                el = el.closest('.w__mobile--submenu');
            }

            if(el.classList.contains('w__mobile--submenu'))
            {
                el.classList.toggle('active');
            }
            else if(el.classList.contains('w__quickfilter--category'))
            {
                el.classList.toggle('active');
            }
            else if(!el.classList.contains('w__js-button') &&
                     el.closest('.w__search-bar--item'))
            {
                el = el.closest('.w__search-bar--item');
                el.classList.toggle('active');
            }
        });
    }

});

class Download
{
    constructor(r)
    {
        this.trackIds = r['trackIds'];
        this.zipId = r['zipId'];
        this.trackKey = 0;
    }

    build_overlay(message)
    {
        if(document.getElementById('w--overlay'))
        {
            document.getElementById('w--overlay').remove();
        }

        this.overlay = create('div', {
            className: 'w__overlay',
            id: 'w--overlay'
        });
        this.container = create('div', {
            className: 'w__overlay--container',
            html: message
        });
        this.status = create('p', {
            className: 'w__download--status',
            text: '0%'
        });
        const closeDiv = create('div',{className: 'w__overlay--close-div'}),
              close = create('span', {className: 'w__icon--circle w__icon--close w__overlay--close'});
        close.addEventListener('click', () => {
            Load.do_request({
                f: 'zip-delete',
                zipId: this.zipId
            });
            this.close();
        });
        closeDiv.appendChild(close);
        this.container.appendChild(this.status);
        this.overlay.appendChild(this.container);
        this.overlay.appendChild(closeDiv);
        document.body.appendChild(this.overlay);
        document.body.classList.add('w__blur');
        document.body.classList.add('w__blur-all');
        document.body.classList.add('w__blur-viewer');
    }

    start()
    {
        Load.do_request({
            f: 'zip-add',
            trackId: this.trackIds[this.trackKey],
            zipId: this.zipId
        },false,false,55000);
    }

    update()
    {
        this.trackKey++;
        this.status.textContent = Math.round(this.trackKey * 100 / this.trackIds.length).toString() + '%';
        if(this.trackIds[this.trackKey])
        {
            this.start();
        }
        else
        {
            this.status.textContent = (lang === 'de') ? 'Erstelle ZIP' : 'Creating ZIP';

            Load.do_request({
                f: 'zip-ready',
                zipId: this.zipId
            },false,false,55000);
        }
    }

    finish(html)
    {
        this.container.innerHTML = html;
        const button = this.container.querySelector('.w__download--link');
        if(button)
        {
            button.addEventListener('click',() => {
                for(let i=0; i<this.trackIds.length; i++)
                {
                    const downloadButtons = document.body.querySelectorAll('.w__track--cmd.download' +
                                                                                    '[data-track-id="' + this.trackIds[i] + '"]');
                    for(let j=0; j<downloadButtons.length; j++)
                    {
                        downloadButtons[j].classList.add('downloaded');
                    }
                }
                this.close();
            });
        }
    }

    close()
    {
        this.trackIds = undefined;
        this.zipId = undefined;
        this.trackKey = undefined;
        this.overlay.remove();
        this.overlay = undefined;
        this.container = undefined;
        if(!(myViewer.active === true ||
             AlbumViewer.active === true))
        {
            document.body.classList.remove('w__blur');
        }
        document.body.classList.remove('w__blur-all');
        document.body.classList.remove('w__blur-viewer');
    }
}

class Filter
{
    static initialize()
    {
        if(Filter.reset === undefined)
        {
            Filter.reset = true;
        }

        if(Filter.reset || Filter.bar === undefined)
        {
            Filter.bar = document.getElementById('w--search-bar');
        }

        if(Filter.reset || Filter.available === undefined)
        {
            Filter.available = Filter.bar.querySelector('.w__search-bar--item.available .w__filter--ul');
        }

        if(Filter.reset || Filter.selected === undefined)
        {
            if(Filter.bar.querySelector('.w__search-bar--item.selected .w__filter--ul'))
            {
                Filter.selected = Filter.bar.querySelector('.w__search-bar--item.selected .w__filter--ul');
            }
            else
            {
                Filter.selected = create('ul', {className: 'w__filter--ul'});
                Filter.bar.querySelector('.w__search-bar--item.selected').appendChild(Filter.selected);
            }
        }

        if(Filter.order === undefined)
        {
            Filter.order = {
                field: 'date',
                direction: 'desc'
            }
        }

        Filter.reset = false;
    }

    static add_filter(el, skipAnimation)
    {
        Filter.initialize();
        const filterAvailable = el.closest('.w__filter--main'),
              filterSelected = Filter.getAdd_filterSelected(filterAvailable),
              filterOption = el.cloneNode(true);
        filterOption.dataset.f = 'filter-remove';
        filterOption.classList.add('none');
        filterSelected.appendChild(filterOption);
        Filter.update_search();

        if(skipAnimation === true)
        {
            filterOption.classList.remove('none');
        }
        else
        {
            animate(el, filterSelected, Filter.available, 'orange',
                () =>
                {
                    filterOption.classList.remove('none');
                });
        }
        el.classList.add('inactive');
    }

    static add_info_filter(el)
    {
        const parentEl = el.closest('li');
        if(parentEl && parentEl.dataset.filterTable)
        {
            Filter.initialize();
            let optionsUl = Filter.selected.querySelector('.w__filter--main[data-filter-table="' +
                                                           parentEl.dataset.filterTable + '"]' +
                                                          '[data-filter-category-id="' +
                                                           parentEl.dataset.filterCategoryId + '"]' +
                                                          ' .w__filter--category-ul');
            const noAnimation = !!(parentEl.dataset.filterTable === 'person' || parentEl.dataset.filterTable === 'publisher');

            if(optionsUl === null)
            {
                let filterName = parentEl.querySelector('.w__track--info-label').textContent.trim();
                filterName = filterName.substr(0,(filterName.length - 1));

                const filterSection = create('li', {
                    className: 'w__filter--main active',
                    dataset: {
                        filterTable: parentEl.dataset.filterTable,
                        filterCategoryId: parentEl.dataset.filterCategoryId,
                        filterSingle: parentEl.dataset.filterSingle,
                        order: parentEl.dataset.order
                    }
                });

                const sectionLabel = create('strong', {
                    className: 'w__filter--label w__js-button',
                    dataset: {
                        f: 'filter-category-remove' + (noAnimation ? '-no-ani' : '')
                    },
                    text: filterName
                });
                optionsUl = create('ul', {
                    className: 'w__filter--category-ul'
                });
                filterSection.appendChild(sectionLabel);
                filterSection.appendChild(optionsUl);
                Filter.insert_filterSelectedCategory(filterSection);
            }

            // only insert if filter does not already exist
            if(optionsUl.querySelector('.w__filter--option[data-filter-id="' + el.dataset.filterId + '"]') === null)
            {
                const filterOption = create('li', {
                    className: 'w__filter--option w__js-button none',
                    dataset: {
                        f: 'filter-remove' + (noAnimation ? '-no-ani' : ''),
                        filterId: el.dataset.filterId
                    },
                    text: el.textContent
                });
                optionsUl.appendChild(filterOption);
                Filter.update_search();
                animate(el, optionsUl, el.parentElement, 'orange', () =>
                {
                    filterOption.classList.remove('none');
                });

                // mark filter in available filters section
                const filterInAvailable = Filter.available.querySelector('.w__filter--main[data-filter-table="' +
                                                                                  parentEl.dataset.filterTable + '"] ' +
                                                                                  '.w__filter--option[data-filter-id="' +
                                                                                  el.dataset.filterId + '"]');
                if(filterInAvailable)
                {
                    filterInAvailable.classList.add('inactive');
                }
            }
        }
    }

    static add_duration(el)
    {
        if(parseInt(el.value) > 0)
        {
            Filter.initialize();
            const value = parseInt(el.value) + ' Sekunden';

            const filterAvailable = el.closest('.w__filter--main'),
                  filterSelected = Filter.getAdd_filterSelected(filterAvailable),
                  filterOption = document.createElement('li');
            filterOption.textContent = value;
            filterOption.classList.add('w__filter--option');
            filterOption.classList.add('w__js-button');
            filterOption.dataset.f = 'filter-remove';
            filterOption.dataset.filterId = 'duration';

            animate(el, filterSelected, Filter.available, 'orange',
                () =>
                {
                    filterSelected.appendChild(filterOption);
                    Filter.update_search();
                });

            el.value = '';
            el.blur();
        }
    }

    static add_word(el)
    {
        if(el.value.trim().length > 2)
        {
            Filter.initialize();
            const value = el.value.trim();
            let words,
                doSearch = false;


            // split by quotation marks to get terms
            if(value.match(/"/))
            {
                words = value.split('"');
                for(let i=0; i<words.length; i++)
                {
                    if(words[i].trim())
                    {
                        let operator = '';
                        if(words[i].length > 2)
                        {
                            words[i] = operator + '&quot;' + words[i].toLowerCase() + '&quot;';
                        }
                    }
                }
            }
            else
            {
                words = value.split(' ');
            }

            // create visible entries
            for(let i=0; i<words.length; i++)
            {
                let myOption;

                while(words[i].substr(0,1) === '+')
                {
                    words[i] = words[i].substr(1);
                }

                if(words[i].length > 2)
                {
                    doSearch = true;

                    if(words[i].length === 3)
                    {
                        words[i] = '*' + words[i] + '*';
                        words[i] = words[i].replace(/[*]+/g, '*');
                    }

                    myOption = document.createElement('li');
                    myOption.classList.add('w__filter--option');
                    myOption.classList.add('w__js-button');
                    myOption.innerHTML = words[i];
                    myOption.dataset.value = words[i].toLowerCase();
                    myOption.dataset.f = 'filter-remove-no-ani';
                    Filter.update_selectedWordFilter(myOption);
                }
            }
            el.value = '';
            el.blur();

            if(doSearch)
            {
                Filter.update_search();
            }
        }
    }

    static remove_filter(el, direct)
    {
        const filterSelected = el.closest('.w__filter--main'),
              filterTable = filterSelected.dataset.filterTable,
              filterCategoryId = filterSelected.dataset.filterCategoryId,
              filterAvailable = Filter.available.querySelector('.w__filter--main' +
                                                                      '[data-filter-table="' + filterTable + '"]' +
                                                                      '[data-filter-category-id="' + filterCategoryId + '"]'),
              filterOption = filterAvailable.querySelector('.w__filter--option[data-filter-id="' + el.dataset.filterId + '"],' +
                                                                    '.w__filter--duration[data-filter-id="' + el.dataset.filterId + '"]');

        let aniTarget = filterOption;

        // if category is no longer open look for closest visible parent
        while(aniTarget.offsetParent === null && !aniTarget.classList.contains('w__filter--main'))
        {
            aniTarget = aniTarget.parentElement;
        }

        animate(el, aniTarget, Filter.selected,
                'blue',
                () => {
                    filterOption.classList.remove('inactive');
                });

        el.remove();

        if(direct === true)
        {
            Filter.remove_category(filterSelected,false);
            Filter.update_search();
        }
    }

    static getAdd_filterSelected(filterAvailable)
    {
        let filterMain,
            filterMainTitle,
            filterSelected;

        if(Filter.selected.querySelector('.w__filter--main' +
                                         '[data-filter-table="' + filterAvailable.dataset.filterTable + '"]' +
                                         '[data-filter-category-id="' + filterAvailable.dataset.filterCategoryId + '"]'))
        {
            filterMain = Filter.selected.querySelector('.w__filter--main' +
                                                       '[data-filter-table="' + filterAvailable.dataset.filterTable + '"]' +
                                                       '[data-filter-category-id="' + filterAvailable.dataset.filterCategoryId + '"]');
            filterSelected = filterMain.querySelector('.w__filter--category-ul');

            // if in a filter category where only one selected option makes sense, remove_filter old selections
            if(filterMain.dataset.filterSingle === '1')
            {
                const selectedFilter = filterSelected.querySelector('.w__filter--option');
                Filter.remove_filter(selectedFilter,false);
            }
        }
        else
        {
            filterMain = filterAvailable.cloneNode();
            filterMain.classList.add('active');
            filterMainTitle = filterAvailable.querySelector('.w__filter--label').cloneNode(true);
            filterMainTitle.dataset.f = 'filter-category-remove';
            filterMain.appendChild(filterMainTitle);
            filterSelected = document.createElement('ul');
            filterSelected.classList.add('w__filter--category-ul');
            filterMain.appendChild(filterSelected);
            Filter.insert_filterSelectedCategory(filterMain);
        }

        return filterSelected;
    }

    static insert_filterSelectedCategory(filterMain)
    {
        const allFilterMain = Filter.selected.querySelectorAll('.w__filter--main');
        let inserted = false;
        for(let i=0; i<allFilterMain.length; i++)
        {
            if(allFilterMain[i].dataset.order > filterMain.dataset.order)
            {
                Filter.selected.insertBefore(filterMain, allFilterMain[i]);
                inserted = true;
                break;
            }
        }

        if(inserted === false)
        {
            Filter.selected.appendChild(filterMain);
        }
    }

    static toggle_category(myCategory)
    {
        // when closing a category close all subcategories
        if(myCategory.classList.contains('active'))
        {
            if(myCategory.querySelector('.active'))
            {
                myCategory.querySelector('.active').classList.remove('active');
            }
        }
        // when opening a new category make sure all categories on the same level get closed
        else
        {
            const parentUl = myCategory.closest('ul');
            if(parentUl.querySelector('.' + myCategory.className + '.active'))
            {
                Filter.toggle_category(parentUl.querySelector('.' + myCategory.className + '.active'));
            }
        }
        myCategory.classList.toggle('active');

        // perform actions on opened category
        if(myCategory.classList.contains('active'))
        {
            Filter.update_hits(myCategory);

            // if opened category contains an input field focus on it
            if(myCategory.querySelector('.w__input--text'))
            {
                myCategory.querySelector('.w__input--text').focus();
            }
        }
    }

    static remove_category(filterSelected, removeOptions)
    {
        let filterOptions = filterSelected.querySelectorAll('.w__filter--option');

        if(removeOptions === true)
        {
            for(let i=0; i<filterOptions.length; i++)
            {
                Filter.remove_filter(filterOptions[i],false);
            }
            filterOptions = [];
        }

        if(filterOptions.length === 0)
        {
            filterSelected.remove();
        }

        if(removeOptions === true)
        {
            Filter.update_search();
        }
    }

    static update_search()
    {
        const filters = Filter.selected.querySelectorAll('.w__filter--main');
        let options,
            search = {},
            table;

        if(filters.length > 0)
        {
            for(let i=0; i<filters.length; i++)
            {
                options = filters[i].querySelectorAll('.w__filter--option');
                if(options.length > 0)
                {
                    table = filters[i].dataset.filterTable;

                    if(search[table] === undefined)
                    {
                        search[table] = [];
                    }

                    for(let j=0; j<options.length; j++)
                    {
                        const k = search[table].length;
                        switch(table)
                        {
                            case 'search':
                                search[table][k] = options[j].textContent.trim();
                                break;

                            case 'duration':
                                search[table][k] = parseInt(options[j].textContent.trim());
                                break;

                            default:
                                search[table][k] = parseInt(options[j].dataset.filterId);
                        }
                    }
                }
            }
        }

        if(Filter.loadTimeout)
        {
            clearTimeout(Filter.loadTimeout);
        }
        document.getElementById('w--track-count').classList.add('out');
        Filter.loadTimeout = setTimeout(() =>
        {
            Load.do_request({
                f: 'search',
                search: search
            });
        },250);
    }

    /**
     * Adds category "Active search terms" if not present
     * Inserts new search term as filter option
     * @param option
     */
    static update_selectedWordFilter(option)
    {
        let category,
            categoryUl;

        if(Filter.selected.querySelector('.w__filter--main.active[data-filter-table="search"]'))
        {
            category = Filter.selected.querySelector('.w__filter--main.active[data-filter-table="search"]');
            categoryUl = category.querySelector('.w__filter--category-ul');
        }

        // if new option first check if category exists
        if(option)
        {
            if(!category)
            {
                const myLabel = document.createElement('strong');
                category = document.createElement('li');
                categoryUl = document.createElement('ul');
                category.classList.add('w__filter--main');
                category.classList.add('active');
                category.dataset.filterTable = 'search';
                category.dataset.order = '-1';
                myLabel.classList.add('w__filter--label');
                myLabel.classList.add('w__js-button');
                myLabel.dataset.f = 'filter-category-remove-no-ani';
                myLabel.textContent = (lang === 'de') ? 'Aktive Suchbegriffe' : 'Active search terms';
                categoryUl.classList.add('w__filter--category-ul');
                category.appendChild(myLabel);
                category.appendChild(categoryUl);
                Filter.selected.insertAdjacentElement('afterbegin', category);
            }

            if(!categoryUl.querySelector('.w__filter--option[data-value="' + option.dataset.value + '"]'))
            {
                categoryUl.appendChild(option);
            }
        }
    }

    static update_hits(categoryContainer, forceOff)
    {
        let optionContainer,
            skipSubcategories = false;

        // get active category if not given
        if(categoryContainer === undefined)
        {
            categoryContainer = Filter.available.querySelector('.active');
        }

        if(categoryContainer)
        {
            if(categoryContainer.classList.contains('w__filter--category'))
            {
                categoryContainer = categoryContainer.closest('.w__filter--main');
                //skipSubcategories = true;
            }

            const table = categoryContainer.dataset.filterTable,
                  categoryId = categoryContainer.dataset.filterCategoryId;

            // case subcategories + options
            if(categoryContainer.querySelector('.w__filter--category'))
            {
                optionContainer = categoryContainer.querySelector('.w__filter--category.active');
            }
            else
            {
                optionContainer = categoryContainer;
                categoryContainer = undefined;
            }

            const optionIds = [],
                  optionHits = {},
                  subcategoryIds = [],
                  subcategoryHits = {};

            if(optionContainer)
            {
                const options = optionContainer.querySelectorAll('.w__filter--option');

                for(let i=0; i<options.length; i++)
                {
                    optionIds[i] = options[i].dataset.filterId;
                    optionHits[optionIds[i]] = 0;
                }
            }

            // also parse subcategories
            if(categoryContainer && skipSubcategories === false)
            {
                const subcategories = categoryContainer.querySelectorAll('.w__filter--category');

                for(let i=0; i<subcategories.length; i++)
                {
                    subcategoryIds[i] = subcategories[i].dataset.categoryId;
                    subcategoryHits[subcategoryIds[i]] = 0;
                }
            }

            if(forceOff === true)
            {
                Filter.apply_hits(table, categoryId, optionHits, subcategoryHits);
            }
            else
            {
                Load.do_request({
                    f: 'hits',
                    table: table,
                    categoryId: categoryId,
                    optionIds: optionIds,
                    subcategoryIds: subcategoryIds
                });
            }
        }
    }

    static apply_hits(table, categoryId, optionHits, subcategoryHits)
    {
        Filter.initialize();
        const myCategory = Filter.available.querySelector('.w__filter--main' +
                                                                  '[data-filter-table="' + table + '"]' +
                                                                  '[data-filter-category-id="' + categoryId + '"]');
        if(myCategory)
        {
            let mySubcategory,
                myOption,
                mySpan;

            if(optionHits)
            {
                Object.getOwnPropertyNames(optionHits).forEach(id =>
                {
                    myOption = myCategory.querySelector('.w__filter--option[data-filter-id="' + id + '"]');
                    if(myOption)
                    {
                        mySpan = myOption.querySelector('.w__hits--track');
                        if(!mySpan)
                        {
                            mySpan = create('span',{className: 'w__hits--track'});
                            myOption.appendChild(mySpan);
                        }
                        mySpan.textContent = optionHits[id];
                    }
                });
            }

            if(subcategoryHits)
            {
                Object.getOwnPropertyNames(subcategoryHits).forEach(id =>
                {
                    mySubcategory = myCategory.querySelector('.w__filter--category[data-category-id="' + id + '"] .w__filter--label');
                    if(mySubcategory)
                    {
                        mySpan = mySubcategory.querySelector('.w__hits--category');
                        if(!mySpan)
                        {
                            mySpan = create('span',{className: 'w__hits--category'});
                            mySubcategory.appendChild(mySpan);
                        }
                        mySpan.textContent = subcategoryHits[id];
                    }
                });
            }
        }
    }
}

class Load
{
    static initialize()
    {
        Load.function = document.body.dataset.function;
        Load.lastUrl = '';
        Load.download = '';
    }

    static do_request(myData, fromHistory, special, timeout)
    {
        if(myData.f)
        {
            myData.tabSessionId = sessionStorage.getItem('tabSessionId');
            myData.lang = lang;

            if(myData.url && myData.f === 'nav')
            {
                if(myData.url !== Load.lastUrl ||
                   fromHistory)
                {
                    Load.set_activeMenu(myData.url);
                    myData.updateSearchbar = (Load.function === 'find-music');
                }
                else
                {
                    return false;
                }
            }

            if(Filter.order &&
                (myData.f === 'autoload' ||
                 myData.f === 'search'))
            {
                myData.order = Filter.order;
            }

            switch(myData.f)
            {
                case 'nav':
                    Filter.reset = true;
                    window.scroll(0,0);
                    break;

                case 'search':
                    window.scroll(0,0);
                    break;
            }

            document.documentElement.classList.add('w__waiting');
            myData.randomData = new Date().getTime();

            const myRequest = new XMLHttpRequest();
            myRequest.onreadystatechange = function()
            {
                if(myRequest.readyState === 4)
                {
                    document.documentElement.classList.remove('w__waiting');
                    if(myRequest.status === 200 && myRequest.response)
                    {
                        let r = (typeof myRequest.response === 'string')
                            ? JSON.parse(myRequest.response) // fix for IE 11 that doesn't honor responseType
                            : myRequest.response;

                        if(r['ok'] === 'OK')
                        {
                            switch(myData.f)
                            {
                                case 'album':
                                    if(fromHistory === true)
                                    {
                                        Load.lastUrl = myData.url;
                                    }
                                    else
                                    {
                                        Load.push_url(myData.url, r['pageTitle']);
                                    }
                                    AlbumViewer.build(r['html'],'w__viewer--with-variants', fromHistory);
                                    break;

                                case 'autoload':
                                    switch(myData.page)
                                    {
                                        case 'find-music':
                                            Load.apply_search(r, false, true);
                                            break;

                                        case 'new-release':
                                        case 'playlist':
                                            Load.insert_moduleItems(r);
                                            break;
                                    }
                                    break;

                                case 'clipboard':
                                    Load.apply_clipboard(myData, r, special);
                                    break;

                                case 'download':
                                    Load.apply_download(myData.trackId, special);
                                    break;

                                case 'drag-and-drop':
                                    document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                                    if(myData.newTrackType === 'complex' && r['html'])
                                    {
                                        special.outerHTML = r['html'];
                                    }
                                    break;

                                case 'form':
                                case 'load-form':
                                    if(r['clipboardCount'])
                                    {
                                        document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                                    }
                                    Load.apply_form(r, special);
                                    break;

                                case 'hits':
                                    Filter.apply_hits(myData.table, myData.categoryId, r['optionHits'], r['subcategoryHits']);
                                    break;

                                case 'location':
                                    Load.apply_location(r);
                                    break;

                                case 'login':
                                case 'profile':
                                    if(r['clipboardCount'])
                                    {
                                        document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                                    }
                                    myViewer = new Viewer('login');
                                    myViewer.start({html: r['html']});
                                    break;

                                case 'logout':
                                    if(r['clipboardCount'])
                                    {
                                        document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                                    }
                                    document.body.classList.remove('w__user-logged-in');
                                    break;

                                case 'nav':
                                    if(fromHistory === true)
                                    {
                                        Load.lastUrl = myData.url;
                                    }
                                    else
                                    {
                                        Load.push_url(myData.url, r['pageTitle']);
                                    }
                                    Viewer.close_all();
                                    Load.apply_nav(r, special);
                                    break;

                                case 'playlist':
                                    if(fromHistory === true)
                                    {
                                        Load.lastUrl = myData.url;
                                        myViewer.mode = 'clipboard';
                                        myViewer.playlistId = r['playlistId'];
                                        myViewer.playlistHash = r['playlistHash'];
                                        myViewer.build(r['html'],'', fromHistory);
                                    }
                                    else
                                    {
                                        if(myData.action === 'view')
                                        {
                                            Load.push_url(myData.url, r['pageTitle']);
                                        }
                                        Load.apply_playlist(myData, r, special);
                                    }
                                    break;

                                case 'search':
                                    Load.apply_search(r,true);
                                    break;

                                case 'trackinfo':
                                    Load.apply_trackinfo(myData.trackId, r, special, true);
                                    break;

                                case 'zip':
                                    Load.download = new Download(r);
                                    Load.download.build_overlay(r['html']);
                                    Load.download.start();
                                    break;

                                case 'zip-add':
                                    if(Load.download)
                                    {
                                        Load.download.update();
                                    }
                                    break;

                                case 'zip-ready':
                                    if(Load.download)
                                    {
                                        Load.download.finish(r['html']);
                                    }
                                    break;
                            }
                        }
                        else if(r['ok'] === 'user-notice')
                        {
                            Load.show_notice(r['html'], r['class'], special);
                        }
                        else
                        {
                            console.error('Not OK', myRequest.response);
                        }
                    }
                    else
                    {
                        console.error('Empty response. Status: ' + myRequest.status);
                    }
                }
            };

            myRequest.ontimeout = function()
            {
                document.documentElement.classList.remove('w__waiting');
                console.error("Timeout");
            };

            myRequest.open("POST", base + 'index.php');
            myRequest.timeout = timeout ? timeout : 25000;
            myRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");
            myRequest.setRequestHeader("Accept", "application/json");
            myRequest.responseType = 'json';
            myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
        }
    }

    static apply_location(r)
    {
        const myOutputField = myViewer.container.querySelector('.w__input--location');
        if(myOutputField)
        {
            myOutputField.innerHTML = r['country_code'] +
                                     (r['country_de'] ? ' / ' + r['country_de'] : '') +
                                     (r['country_en'] ? ' / ' + r['country_en'] : '') +
                                     (r['html'] ? ' ' + r['html'] : '');
            myOutputField.classList.remove('w__input--location');
        }
        const myCountryCode = myViewer.container.querySelector('input[name="country_code"]');
        if(myCountryCode)
        {
            myCountryCode.value = r['country_code'];
        }
        const myCountryNameDe = myViewer.container.querySelector('input[name="country_de"]');
        if(myCountryNameDe)
        {
            myCountryNameDe.value = r['country_de'];
        }
        const myCountryNameEn = myViewer.container.querySelector('input[name="country_en"]');
        if(myCountryNameEn)
        {
            myCountryNameEn.value = r['country_en'];
        }
        myViewer.check_form(myOutputField.closest('.w__viewer--form'));
    }

    static apply_clipboard(myData, r, el)
    {
        switch(myData.action)
        {
            case 'add-track':
                animate(el.querySelector('.w__track--icon'),
                        (myBrowser.mobile === true
                            ? document.getElementById('w--mobile-menu-button')
                            : document.getElementById('w--clipboard-count')
                                      .closest('.w__icon--circle')
                                      .querySelector('.w__menu--icon')),
                        document.body,
                       '',
                       () => {
                            document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                        },
                       375);
                el.classList.add('selected');
                mark_clipboardButton(el.dataset.trackId);
                break;

            case 'add-album':
            case 'add-playlist':
                document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                const allTracks = (myData.action === 'add-album')
                                    ? AlbumViewer.container.querySelectorAll('.w__track--cmd.clipboard:not(.selected)')
                                    : myViewer.container.querySelectorAll('.w__track--cmd.clipboard:not(.selected)');
                for(let i=0; i<allTracks.length; i++)
                {
                    allTracks[i].classList.add('selected');
                    mark_clipboardButton(allTracks[i].dataset.trackId);
                }
                break;

            case 'del-track':
                document.getElementById('w--clipboard-count').textContent = r['clipboardCount'];
                myViewer.playlist_updateList(el);
                break;

            case 'reset':
                document.getElementById('w--clipboard-count').textContent = '0';
                myViewer.playlist_empty(r['html']);
                break;

            case 'show-save-form':
                myViewer.playlist_save(r['html']);
                break;

            case 'save-as-playlist':
                if(myData.data &&
                   myData.data.keepClipboard === false)
                {
                    document.getElementById('w--clipboard-count').textContent = '0';
                    myViewer.playlist_empty();
                }
                myViewer.playlist_saveAsPlaylist(myData, r, el);
                break;

            case 'show-clipboard':
                myViewer = new Viewer('clipboard');
                myViewer.start({html: r['html']});
                break;
        }
    }

    static apply_download(trackId, el)
    {
        const dlContainer = create('div',{className: 'w__download--div'}),
              dlWav = create('span',
                  {
                      className: 'w__js-button w__download--button',
                      text: 'WAV',
                      dataset: {
                        f: 'zip',
                        type: 'track',
                        filetype: 'wav',
                        id: trackId
                      }
                  }),
              dlMp3 = create('a',
                  {
                      className: 'direct-download w__download--button',
                      text: "MP3",
                  });
        dlMp3.href = base + 'download.php?type=mp3&trackId=' + trackId + '&lang=' + lang;
        dlMp3.title = 'MP3 (320 kBit)';
        dlWav.title = 'WAV+Metadata (ZIP)';
        dlContainer.appendChild(dlWav);
        dlContainer.appendChild(dlMp3);
        el.classList.add('active');
        el.appendChild(dlContainer);
    }

    static apply_form(r, formEl)
    {
        if(r['type'] &&
           formEl &&
           formEl.closest('.w__viewer--inner-div'))
        {
            if(r['type'] === 'replace' &&
               r['html'])
            {
                formEl.closest('.w__viewer--inner-div').innerHTML = r['html'];
            }
            else if(r['type'] === 'close' &&
                    myViewer.active === true)
            {
                if(r['html'] === 'user-logged-in')
                {
                    document.body.classList.add('w__user-logged-in');
                }
                myViewer.close(true);
            }
            else if(r['type'] === 'notice' &&
                    r['html'])
            {
                let existingNotice = formEl.querySelector('.w__viewer--notice');
                if(!existingNotice)
                {
                    existingNotice = create('p',{className: 'w__viewer--notice'});
                    formEl.querySelector('.w__input--submit').insertAdjacentElement('beforebegin', existingNotice);
                }
                existingNotice.innerHTML = r['html'];
            }
        }
    }

    /**
     * insert result of incremental navigation into page
     *
     * @param r
     * @param special
     */
    static apply_nav(r, special)
    {
        document.body.classList.remove('w__text-only');

        if(Header.playing === false)
        {
            document.body.classList.remove('w__mode--music');
        }
        else if(document.body.dataset.viewClass)
        {
            document.body.classList.add('w__' + document.body.dataset.viewClass);
        }

        if(r['bodyClass'])
        {
            const myClasses = r['bodyClass'].split(' ');
            for(let i=0; i<myClasses.length; i++)
            {
                document.body.classList.add(myClasses[i]);
            }
        }

        document.body.dataset.function = r['function'];
        Load.function = r['function'];

        // searchBar
        const searchBar = document.getElementById('w--search-bar');

        // set or remove tracks
        let tracks = document.getElementById('w--tracks');
        if(r['w--tracks'])
        {
            if(!tracks)
            {
                tracks = create('div', {className: 'w__tracks--div', id: 'w--tracks'});
                document.body.appendChild(tracks);
            }

            if(Load.remTracklist && Load.remSearchbar && !special)
            {
                tracks.innerHTML = Load.remTracklist;
                searchBar.innerHTML = Load.remSearchbar;
                Filter.initialize();
            }
            else
            {
                tracks.innerHTML = r['w--tracks'];
                searchBar.innerHTML = r['w--search-bar'];
            }

            delete r['w--search-bar'];
            delete Load.remTracklist;
            delete Load.remSearchbar;

            Audioplayer.reset_playIndicators();
        }
        else if(tracks)
        {
            Load.remTracklist = tracks.innerHTML;
            Load.remSearchbar = searchBar.innerHTML;
            tracks.remove();
        }

        // set or remove article
        let myArticle = document.getElementById('w--article');
        if(r['html'])
        {
            if(!myArticle)
            {
                myArticle = create('article',{className: 'w__article', id: 'w--article'});
                document.body.appendChild(myArticle);
            }
            myArticle.innerHTML = r['html'];
        }
        else if(myArticle)
        {
            myArticle.remove();
        }

        // set search bar
        if(r['w--search-bar'])
        {
            searchBar.innerHTML = r['w--search-bar'];
        }

        // add images to header
        if(r['w--header'])
        {
            Header.replace_images(r['w--header']);
        }

        // music search initiated through search bar on other page
        if(special)
        {
            if(special.filter)
            {
                Load.apply_filter(special.filter);
            }
            else if(special.word)
            {
                if(document.getElementById('w--search-bar')
                           .querySelector('.w__fulltext-search--input'))
                {
                    const myInput = document.getElementById('w--search-bar')
                                            .querySelector('.w__fulltext-search--input');
                    myInput.value = special.word;
                    Filter.add_word(myInput);
                }
            }
        }

        // force rendering of search bar
        searchBar.offsetHeight;
    }

    static apply_playlist(myData, r, el)
    {
        if(myViewer.active &&
           myViewer.mode === 'clipboard')
        {
            switch(myData.action)
            {
                case 'close':
                    myViewer.clipboardTracks.innerHTML = r['html'];
                    myViewer.adjustView_clipboard();
                    do_onScroll(true);
                    break;

                case 'del-track':
                    myViewer.playlist_updateList(el);
                    break;

                case 'delete-confirmed':
                    const viewedTrack = myViewer.playlistAvailable.querySelector('.w__playlist--item.viewed');
                    if(viewedTrack)
                    {
                        viewedTrack.remove();
                    }
                    myViewer.playlist_switch('clipboard');
                    myViewer.clipboardTracks.innerHTML = r['html'];
                    break;

                case 'edit':
                    myViewer.playlist_view(r, el);
                    break;

                case 'load':
                    myViewer.playlist_load(r, el);
                    break;

                case 'reset':
                    myViewer.playlist_empty(r['html']);
                    break;

                case 'save-as-playlist':
                    myViewer.playlist_saveAsPlaylist(myData, r, el);
                    break;

                case 'save-on-change':
                    if(r['fieldName'])
                    {
                        myViewer.playlist_updateViewed(r['fieldName'], r['value']);
                    }
                    break;

                case 'show-save-form':
                    myViewer.playlist_save(r['html']);
                    break;
            }
        }
        else if(myData.action === 'view')
        {
            myViewer.build(r['html']);
        }
    }

    static apply_search(r, emptyTrackDiv, autoload)
    {
        if(r['w--track-count-text'])
        {
            const trackCountEl = document.getElementById('w--track-count');
            trackCountEl.innerHTML = r['w--track-count-text'];
            trackCountEl.classList.remove('out');
        }

        const trackDiv = document.getElementById('w--tracks');

        if(r['w--tracks'])
        {
            trackDiv.innerHTML = r['w--tracks'];
        }
        else
        {
            if(r['album'])
            {
                const remTrackId = [];

                if(emptyTrackDiv === true)
                {
                    trackDiv.innerHTML = '';
                }

                for(let i=0; i<r['album'].length; i++)
                {
                    const albumUl = create('ul',{
                            className: 'w__track--album-ul',
                            id: 'w--album-' + r['album'][i]["albumId"],
                            dataset: {
                                albumId: r['album'][i]["albumId"],
                                albumCode: r['album'][i]["albumCode"]
                            }}),
                          trackLi = create('li',{className: 'w__track album', html: r['album'][i]["track"]}),
                          variantUl = create('ul',{className: 'w__track--variant-ul', id: 'w--track-' + r['album'][i]["trackId"]});
                    trackLi.appendChild(variantUl);
                    albumUl.appendChild(trackLi);
                    trackDiv.appendChild(albumUl);
                    remTrackId[remTrackId.length] = r['album'][i]["trackId"];
                }

                Object.getOwnPropertyNames(r['trackMain']).forEach(no =>
                {
                    const trackId = r['trackMain'][no]['trackId'];
                    const albumUl = document.getElementById('w--album-' + r['trackMain'][no]['albumId']);
                    if(albumUl)
                    {
                        const trackLi = create('li',{className: 'w__track main', html: r['trackMain'][no]["track"]}),
                              variantUl = create('ul',{className: 'w__track--variant-ul', id: 'w--track-' + trackId});
                        trackLi.appendChild(variantUl);
                        albumUl.appendChild(trackLi);
                    }
                    remTrackId[remTrackId.length] = trackId;
                });

                Object.getOwnPropertyNames(r['trackVariant']).forEach(no =>
                {
                    const trackUl = document.getElementById('w--track-' + r['trackVariant'][no]['mainTrackId']);
                    if(trackUl)
                    {
                        trackUl.closest('.w__track').classList.add('w__track--with-variant');
                        const trackLi = create('li', {className: 'w__track variant', html: r['trackVariant'][no]["track"]});
                        trackUl.appendChild(trackLi);
                    }
                });

                for(let i=0; i<remTrackId.length; i++)
                {
                    const variantUl = document.getElementById('w--track-' + remTrackId[i]);
                    if(variantUl)
                    {
                        const variantIcon = variantUl.closest('.w__track').querySelector('.w__track--cmd.variant .w__icon--circle'),
                              variantCount = variantUl.querySelectorAll('.w__track.variant').length;
                        if(variantIcon && variantCount)
                        {
                            const variantCountSpan = create('span',{
                                text: variantCount,
                                className: 'w__track--variant-count'
                            });
                            variantIcon.appendChild(variantCountSpan);
                        }
                    }
                }
            }
            if(r['autoload'])
            {
                trackDiv.appendChild(create('div',{className: 'w__autoload',
                                                            id: 'w--autoload',
                                                            html: 'Loading ...',
                                                            dataset: {limitStart: r['autoload']}}));
            }
            if(Audioplayer.audioId)
            {
                Audioplayer.update_playIndicators();
            }
        }

        if(!autoload)
        {
            Filter.update_hits(undefined, (r['w--track-count'] === 0));
        }
        do_onScroll();
    }

    static apply_trackinfo(trackId, r, infoButton, doNotAdjust)
    {
        const track = infoButton.closest('.w__track'),
              oldTrackInfo = track.querySelector('.w__track--info');
        if(oldTrackInfo)
        {
            oldTrackInfo.remove();
        }
        if(r['html'])
        {
            const trackInfo = create('div',{className: 'w__track--info', html: r['html']});
            track.querySelector('.w__track--waveform-span,.w__viewer--track-waveform').insertAdjacentElement('afterend', trackInfo);
            //Audioplayer.update_playIndicators();
        }
        else
        {
            infoButton.classList.remove('active');
        }
        Audioplayer.update_coverPosition();
        if(AlbumViewer.active)
        {
            AlbumViewer.adjustView_album(false);
        }
        else if(myViewer.active &&
                myViewer.mode === 'clipboard' &&
                doNotAdjust !== true)
        {
            myViewer.adjustView_clipboard();
        }
    }

    static insert_moduleItems(r)
    {
        const moduleDiv = document.body.querySelector('.w__module--flex-wide');
        if(moduleDiv &&
           r['item'] && r['item'].length > 0)
        {
            for(let i=0; i<r['item'].length; i++)
            {
                const newItem = create('section',{className: 'w__module--item', html: r['item'][i]});
                moduleDiv.appendChild(newItem);
            }

            if(r['autoload'])
            {
                moduleDiv.appendChild(create('div',{
                    className: 'w__autoload',
                    id: 'w--autoload',
                    html: 'Loading ...',
                    dataset: {limitStart: r['autoload']}
                }));
            }
        }
    }

    static get_menuHref(f)
    {
        return document.getElementById('w--menu')
                       .querySelector('.w__menu--link[data-function="' + f + '"]')
                       .getAttribute('href')
    }

    static apply_filter(f)
    {
        Filter.initialize();
        const filterMain = Filter.available.querySelector('.w__filter--main[data-filter-table="' + f.table + '"]' +
                                                                    '[data-filter-category-id="' + f.categoryId + '"]'),
              filterOption = filterMain.querySelector( '.w__filter--option[data-filter-id="' + f.filterId + '"]');

        // add_filter filter to selected
        Filter.add_filter(filterOption, true);
    }

    /**
     * push url to history; returns true only if new page has been pushed
     *
     * @param newUrl
     * @param pageTitle
     * @param replace
     * @returns {boolean}
     */
    static push_url(newUrl, pageTitle, replace)
    {
        let changed = false;

        if(newUrl !== Load.lastUrl)
        {
            document.title = pageTitle;
            (replace === true)
                ? window.history.replaceState({v: newUrl}, pageTitle, newUrl)
                : window.history.pushState({v: newUrl}, pageTitle, newUrl);
            Load.lastUrl = newUrl;
            changed = true;
        }

        return changed;
    }

    static set_activeMenu(href)
    {
        const mainMenuActive = document.body.querySelector('.w__menu li.active'),
              mainMenuClicked = document.body.querySelector('.w__menu .w__menu--link[href="' + href + '"]'),
              footerMenuActive = document.body.querySelector('.w__footer--menu li.active'),
              footerMenuClicked = document.body.querySelector('.w__footer--menu a[href="' + href + '"]');
        if(mainMenuActive)
        {
            mainMenuActive.classList.remove('active');
        }
        else if(footerMenuActive)
        {
            footerMenuActive.classList.remove('active');
        }
        if(mainMenuClicked)
        {
            mainMenuClicked.closest('li').classList.add('active');
        }
        else if(footerMenuClicked)
        {
            footerMenuClicked.closest('li').classList.add('active');
        }
    }

    static show_notice(myText, myClass, el)
    {
        if(document.getElementById('w--notice'))
        {
            document.getElementById('w--notice').remove();
        }
        const myNotice = create('div',{id: 'w--notice', className: 'w__notice out ' + myClass, html: myText});
        let timeout = 3000;

        if(myClass === 'w__notice--download')
        {
            const closeButton = create('span', {className: 'w__notice--close'}),
                  elPos = get_elementInfo(el);
            myNotice.style.top = (elPos.top + 22) + 'px';
            myNotice.style.left = (elPos.left + 22) + 'px';
            timeout = 10000;
            closeButton.addEventListener('click', () => {
                myNotice.classList.add('out');
                setTimeout(() =>
                {
                    myNotice.remove();
                }, 250);
            });
            myNotice.insertAdjacentElement('afterbegin', closeButton);
        }

        document.body.appendChild(myNotice);
        myNotice.offsetHeight;
        if(myNotice.getBoundingClientRect()['left'] + myNotice.getBoundingClientRect()['width'] > myScreen.x)
        {
            const moveX = Math.ceil(myScreen.x - myNotice.getBoundingClientRect()['left'] - myNotice.getBoundingClientRect()['width']) - 5;
            myNotice.style.marginLeft = moveX.toString() + 'px';
        }
        myNotice.classList.remove('out');

        setTimeout(() =>
        {
            myNotice.classList.add('out');
            setTimeout(() =>
            {
                myNotice.remove();
            }, 250);
        }, timeout);
    }
}

class Audioplayer
{
    static initialize()
    {
        Audioplayer.player = new Audio();
        Audioplayer.player.addEventListener('ended',() =>
        {
            Audioplayer.set_paused();
            Audioplayer.update_time();
            Audioplayer.play_next();
        });
        Audioplayer.player.addEventListener('timeupdate',() =>
        {
            Audioplayer.update_needle(Audioplayer.player.currentTime * 100 / Audioplayer.player.duration);
        });
    }

    static start(el, noAutoplay)
    {
        if(el)
        {
            if(el.dataset.audioId &&
                el.dataset['audioFile'] &&
                el.dataset.audioId !== Audioplayer.audioId)
            {
                // stop any running animation
                Audioplayer.set_paused(true);

                // get new track button
                Audioplayer.playButton = el;

                // get new audio id and filename from track button
                Audioplayer.audioId = el.dataset.audioId;
                Audioplayer.audioFilename = el.dataset.audioId + '_' + el.dataset['audioFile'];

                // get album id and code
                const coverInfoSrc = (myViewer.active === true)
                    ? el.closest('.w__track').querySelector('.w__track--album-cover-span')
                    : el.closest('.w__track--album-ul');
                Audioplayer.albumId = coverInfoSrc.dataset.albumId;
                Audioplayer.albumCode = coverInfoSrc.dataset.albumCode;

                // if no audio player yet initialize
                if(Audioplayer.player === undefined)
                {
                    Audioplayer.initialize();
                }

                // set audio source
                Audioplayer.player.src = base + 'db/audio/mp3_96/' + Audioplayer.audioFilename + '.mp3';

                if(myBrowser.os === 'ios')
                {
                    Audioplayer.prepare_playback();
                    if(!noAutoplay)
                    {
                        Audioplayer.play_orPause();
                    }
                }
                else
                {
                    // start playing once partially loaded
                    Audioplayer.player.oncanplay = () =>
                    {
                        Audioplayer.prepare_playback();
                        if(!noAutoplay)
                        {
                            Audioplayer.play_orPause();
                        }
                        Audioplayer.player.oncanplay = undefined;
                    }
                }
            }
            // actions if track play button is clicked again
            else if(el.dataset.audioId === Audioplayer.audioId)
            {
                // special case; album got called from history
                if(noAutoplay === true)
                {
                    Audioplayer.playButton = el;
                }else
                {
                    Audioplayer.play_orPause();
                }
            }
        }
    }

    static check_inView()
    {
        if(Audioplayer.playButton)
        {
            const elPos = get_elementInfo(Audioplayer.playButton)['top'],
                  offsetPos = get_elementInfo(document.getElementById('w--search-bar'))['top'];

            if(elPos > (myScreen.y - (AlbumViewer.active === true ? 75 : 150)) || (elPos - offsetPos - 150) < 0)
            {
                Audioplayer.update_scrollPosition();
            }
        }
    }

    static seek(e, seconds)
    {
        if(Audioplayer.player)
        {
            let percent = 0;
            if(e)
            {
                percent = (e.clientX * 100 / myScreen.x);
                Audioplayer.player.currentTime = Audioplayer.player.duration * percent / 100;
            }
            else if(seconds)
            {
                Audioplayer.player.currentTime += seconds;
                percent = Audioplayer.player.currentTime * 100 / Audioplayer.player.duration;
            }

            Audioplayer.needle.classList.add('no-transition');
            Audioplayer.update_needle(percent);
            Audioplayer.needle.offsetHeight;
            Audioplayer.needle.classList.remove('no-transition');
            if(Audioplayer.player.paused)
            {
                Audioplayer.play_orPause();
            }
        }
    }

    static play_orPause()
    {
        if(Audioplayer.player)
        {
            if(Audioplayer.player.paused)
            {
                if(Audioplayer.player.play() || ie11)
                {
                    Audioplayer.set_playing();
                }
            }
            else
            {
                Audioplayer.player.pause();
                Audioplayer.set_paused(true);
            }
        }
    }

    static stop(startingViewer)
    {
        if(Audioplayer.player)
        {
            // update player, cover etc.
            Audioplayer.player.pause();
            Audioplayer.player.currentTime = 0;
            Audioplayer.update_needle();
            Audioplayer.set_paused();

            // remove Elements
            if(Audioplayer.controls)
            {
                Audioplayer.controls.container.remove();
            }
            if(Audioplayer.waveform)
            {
                Audioplayer.waveform.remove();
            }
            if(Audioplayer.needle)
            {
                Audioplayer.needle.remove();
            }

            // reset variables
            Audioplayer.controls = undefined;
            Audioplayer.playButton = undefined;
            Audioplayer.cover = undefined;
            Audioplayer.albumId = undefined;
            Audioplayer.albumCode = undefined;
            Audioplayer.audioId = undefined;
            Audioplayer.audioFilename = undefined;
            Audioplayer.waveform = undefined;
            Audioplayer.needle = undefined;

            // change header
            if(!startingViewer)
            {
                Header.playing = false;
                Header.parent.classList.remove('w__header--playing');
                if(Load.function !== "find-music")
                {
                    document.body.classList.remove('w__mode--music');
                }
            }
        }
    }

    static play_next(autoscroll)
    {
        if(Audioplayer.playButton)
        {
            let nextButton,
                trackLi = Audioplayer.playButton.closest('.w__track');

            if(trackLi)
            {
                if(AlbumViewer.active === true && AlbumViewer.trackVariants === false)
                {
                    while(!nextButton && trackLi.nextElementSibling)
                    {
                        trackLi = trackLi.nextElementSibling;
                        if(trackLi.classList.contains('w__track') &&
                           trackLi.classList.contains('main'))
                        {
                            nextButton = trackLi.querySelector('.w__track--cmd.play');
                        }
                    }
                }
                else
                {
                    const variantTrackLi = trackLi.querySelector('.w__track--variant-ul.active .w__track.variant');

                    // if main track and opened variant play variant
                    if(variantTrackLi)
                    {
                        nextButton = variantTrackLi.querySelector('.w__track--cmd.play');
                    }
                    // if main track or variant and next track available play next track
                    else if(trackLi.nextElementSibling)
                    {
                        nextButton = trackLi.nextElementSibling.querySelector('.w__track--cmd.play');
                    }
                    // if variant and no next variant track move to next main track
                    else if(trackLi.classList.contains('variant') &&
                        trackLi.closest('.w__track:not(.variant)').nextElementSibling)
                    {
                        nextButton = trackLi.closest('.w__track:not(.variant)')
                            .nextElementSibling
                            .querySelector('.w__track--cmd.play');
                    }
                    // if no main track available move to next album
                    else if(trackLi.closest('.w__track--album-ul').nextElementSibling &&
                        trackLi.closest('.w__track--album-ul').nextElementSibling.classList.contains('w__track--album-ul'))
                    {
                        nextButton = trackLi.closest('.w__track--album-ul')
                            .nextElementSibling
                            .querySelector('.w__track--cmd.play');
                    }
                    else if(AlbumViewer.active === false &&
                            myViewer.mode !== 'clipboard')
                    {
                        nextButton = document.getElementById('w--tracks').querySelector('.w__track--cmd.play');
                        if(nextButton === Audioplayer.playButton)
                        {
                            nextButton = false;
                        }
                    }
                }

                // if button is found, activate it
                if(nextButton)
                {
                    Audioplayer.start(nextButton);

                    if(autoscroll)
                    {
                        Audioplayer.check_inView();
                    }
                }

                return nextButton;
            }
        }
    }

    static play_previous(autoscroll)
    {
        if(Audioplayer.playButton)
        {
            let prevButton,
                trackLi = Audioplayer.playButton.closest('.w__track');
            if(trackLi)
            {
                if(AlbumViewer.active === true && AlbumViewer.trackVariants === false)
                {
                    while(!prevButton && trackLi.previousElementSibling)
                    {
                        trackLi = trackLi.previousElementSibling;
                        if(trackLi.classList.contains('w__track') &&
                            trackLi.classList.contains('main'))
                        {
                            prevButton = trackLi.querySelector('.w__track--cmd.play');
                        }
                    }
                }
                else
                {
                    // if main track or variant and previous track available play previous track
                    if(trackLi.previousElementSibling)
                    {
                        const variantTrackLi = trackLi.previousElementSibling
                            .querySelector('.w__track--variant-ul.active .w__track.variant:last-child');

                        prevButton = variantTrackLi
                            ? variantTrackLi.querySelector('.w__track--cmd.play')
                            : trackLi.previousElementSibling.querySelector('.w__track--cmd.play');
                    }
                    // if variant and no previous variant track move to main track
                    else if(trackLi.classList.contains('variant'))
                    {
                        prevButton = trackLi.closest('.w__track:not(.variant)')
                            .querySelector('.w__track--cmd.play');
                    }
                    // if no main track available move to next album
                    else if(trackLi.closest('.w__track--album-ul').previousElementSibling &&
                        trackLi.closest('.w__track--album-ul').previousElementSibling.classList.contains('w__track--album-ul'))
                    {
                        const lastTrack = trackLi.closest('.w__track--album-ul')
                                .previousElementSibling
                                .querySelector('.w__track:not(.variant):last-child'),
                            lastTrackVariant = lastTrack.querySelector('.w__track--variant-ul.active .w__track.variant:last-child');

                        prevButton = lastTrackVariant
                            ? lastTrackVariant.querySelector('.w__track--cmd.play')
                            : lastTrack.querySelector('.w__track--cmd.play');
                    }
                }

                // if button is found activate it
                if(prevButton)
                {
                    Audioplayer.start(prevButton);

                    if(autoscroll)
                    {
                        Audioplayer.check_inView();
                    }
                }
            }
            return prevButton;
        }
    }

    static prepare_playback()
    {
        if(!Audioplayer.waveform)
        {
            Audioplayer.waveform = create('img',{className: 'w__header--img w__header--wav w__js-button', id: 'w--wav', dataset:
                    {
                        f: 'audio-seek'
                    }});
            Header.parent.appendChild(Audioplayer.waveform);
        }

        if(!Audioplayer.controls)
        {
            // control elements that can be modified
            Audioplayer.controls = {
                container: create('div',{className: 'w__player--controls'}),
                title: create('span',{className: 'w__player--controls-title'}),
                play: create('span',{className: 'w__player--controls-play w__js-button', dataset: {f: 'audio-play-pause'}}),
                timeDisplay: create('span',{className: 'w__player--controls-time-display'}),
                currentTime: create('span',{className: 'w__player--controls-time'}),
                duration: create('span',{className: 'w__player--controls-duration'}),
                cover: create('img',{className: 'w__player--cover w__js-button', dataset: {f: 'album'}})
            };

            // control elements that won't be modified
            const ctrlPrev = create('span',{className: 'w__player--controls-prev w__js-button', dataset: {f: 'audio-prev'}}),
                  ctrlNext = create('span',{className: 'w__player--controls-next w__js-button', dataset: {f: 'audio-next'}}),
                  ctrlClose = create('span',{className: 'w__player--controls-close w__js-button', dataset: {f: 'audio-close'}});

            Audioplayer.controls.container.appendChild(Audioplayer.controls.title);
            Audioplayer.controls.container.appendChild(ctrlPrev);
            Audioplayer.controls.container.appendChild(Audioplayer.controls.play);
            Audioplayer.controls.container.appendChild(ctrlNext);
            Audioplayer.controls.container.appendChild(Audioplayer.controls.timeDisplay);
            Audioplayer.controls.timeDisplay.appendChild(Audioplayer.controls.currentTime);
            Audioplayer.controls.timeDisplay.appendChild(Audioplayer.controls.duration);
            Audioplayer.controls.container.appendChild(Audioplayer.controls.cover);
            Audioplayer.controls.container.appendChild(ctrlClose);
            if(document.getElementById('w--nav'))
            {
                document.getElementById('w--nav').appendChild(Audioplayer.controls.container);
            }
        }

        const trackCover = (myViewer.active === true)
                            ? Audioplayer.playButton.closest('.w__track').querySelector('.w__track--album-cover')
                            : Audioplayer.playButton.closest('.w__track--album-ul').querySelector('.w__track--album-cover'),
              trackTitle = Audioplayer.playButton.closest('.w__track:not(.variant)').querySelector('.w__track--title').textContent,
              trackVariantEl = Audioplayer.playButton.closest('.w__track').querySelector('.w__track--version');

        Audioplayer.controls.title.innerHTML = '<b>' + trackTitle + '</b>' + (trackVariantEl ? ' <span>' + trackVariantEl.textContent + '</span>' : '');
        Audioplayer.controls.currentTime.textContent = '0:00';
        const myDuration = Audioplayer.player.duration;
        Audioplayer.controls.duration.textContent = isNaN(myDuration) ? '' : '/ ' + Audioplayer.rewrite_seconds(myDuration);
        Audioplayer.controls.cover.src = trackCover.src;

        if(Audioplayer.albumId)
        {
            Audioplayer.controls.cover.dataset.albumId = Audioplayer.albumId;
        }
        if(Audioplayer.albumCode)
        {
            Audioplayer.controls.cover.dataset.albumCode = Audioplayer.albumCode;
        }

        if(!Audioplayer.needle)
        {
            Audioplayer.needle = create('div',{className: 'w__player--needle w__js-button', dataset:
                    {
                        f: 'audio-seek'
                    }});
            Header.parent.appendChild(Audioplayer.needle);
        }

        Audioplayer.waveform.src = base + 'db/audio/svg/' + Audioplayer.audioFilename + '.svg';
        Header.playing = true;
        Header.parent.classList.add('w__header--playing');

        Audioplayer.adjust_waveform();
    }

    // ie11 does not scale the waveform svgs
    // function applies transform scale() as a workaround
    static adjust_waveform()
    {
        if(ie11)
        {
            if(Audioplayer.waveform)
            {
                Audioplayer.waveform.style.transform = 'scale(' + (myScreen.x / 1920) + ')';
            }

            let tracks = (AlbumViewer && AlbumViewer.active === true) ? AlbumViewer.container : document.getElementById('w--tracks');
            if(tracks && tracks.classList.contains('w__tracks--show-wav'))
            {
                if(AlbumViewer && AlbumViewer.active === true)
                {
                    tracks = tracks.querySelector('.w__viewer--album-tracks');
                }

                const myWavs = tracks.querySelectorAll('.w__track--waveform'),
                      scaleFactor = (parseInt(get_elementInfo(tracks)['width']) - 490) / 1920;

                for(let i=0; i<myWavs.length; i++)
                {
                    myWavs[i].style.transform = 'scale(' + scaleFactor + ')';
                }
            }
        }
    }

    static rewrite_seconds(seconds)
    {
        return Math.floor(seconds / 60) + ':' + ('00' + Math.floor(seconds % 60)).substr(-2);
    }

    static set_playing()
    {
        Audioplayer.playing = true;

        if(Audioplayer.playButton)
        {
            Audioplayer.playButton.classList.add('active');

            Audioplayer.cover = (myViewer.active === true)
                ? Audioplayer.playButton.closest('.w__track').querySelector('.w__track--album-cover')
                : Audioplayer.playButton.closest('.w__track--album-ul').querySelector('.w__track--album-cover');

            // start spinning the cover
            Audioplayer.cover.classList.add('playing');

            // update cover position to match track
            Audioplayer.update_coverPosition();
        }

        if(Audioplayer.controls)
        {
            Audioplayer.controls.play.classList.add('active');
        }
    }

    static set_paused(stayOnTrack, doNotUpdateNeedle)
    {
        Audioplayer.playing = false;

        if(Audioplayer.playButton)
        {
            Audioplayer.playButton.classList.remove('active');
        }
        if(Audioplayer.controls)
        {
            Audioplayer.controls.play.classList.remove('active');
        }

        if(Audioplayer.cover)
        {
            const myStyle = window.getComputedStyle(Audioplayer.cover).transform;

            Audioplayer.cover.classList.remove('playing');
            Audioplayer.cover.style.transform = myStyle;
            Audioplayer.cover.offsetHeight;
            Audioplayer.cover.style.transform = 'none';

            if(!stayOnTrack && Audioplayer.cover.closest('.w__track--album-cover-span'))
            {
                Audioplayer.cover.closest('.w__track--album-cover-span').removeAttribute('style');
            }
        }

        if(AlbumViewer.active === false)
        {
            if(document.getElementById('w--tracks'))
            {
                const activePlayButton = document.body.querySelector('.w__track--cmd.play.active');
                if(activePlayButton)
                {
                    activePlayButton.classList.remove('active');
                }
            }

            if(doNotUpdateNeedle !== true)
            {
                Audioplayer.update_needle(0);
            }
        }
    }

    static update_playIndicators()
    {
        const tracks = document.getElementById('w--tracks');
        if(tracks)
        {
            const playButton = tracks.querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
            if(playButton)
            {
                Audioplayer.playButton = playButton;
                if(Audioplayer.playing === true)
                {
                    Audioplayer.set_playing();
                }
                else
                {
                    Audioplayer.cover = Audioplayer.playButton.closest('.w__track--album-ul')
                                                              .querySelector('.w__track--album-cover');
                    Audioplayer.update_coverPosition();
                }
            }
        }
    }

    static reset_playIndicators()
    {
        if(!Audioplayer.playing)
        {
            // reset leftover buttons/states
            const myCoverPlaying = document.body.querySelector('.w__track--album-cover.playing');
            if(myCoverPlaying)
            {
                myCoverPlaying.classList.remove('playing');
            }
            const myPlayButton = document.body.querySelector('.w__track--cmd.play.active');
            if(myPlayButton)
            {
                myPlayButton.classList.remove('active');
            }
        }
    }

    static update_coverPosition()
    {
        if(myViewer.active !== true &&
           Audioplayer.playButton &&
           Audioplayer.cover)
        {
            let adjustPosY = 0,
                track = Audioplayer.playButton.closest('.w__track--flex');
            const coverSpan = Audioplayer.cover.closest('.w__track--album-cover-span'),
                  trackVariantUl = track.closest('.w__track--variant-ul');

            // special case if variant list closed on active track go to main track
            if(trackVariantUl)
            {
               if(trackVariantUl.classList.contains('active'))
               {
                   adjustPosY = (myBrowser.mobile === true) ? 5 : -10;
               }
               else
               {
                   track = trackVariantUl.closest('.w__track').querySelector(('.w__track--flex'));
               }
            }

            const targetPosY = Math.round(get_elementInfo(track)['top']),
                  initialPosY = Math.round(get_elementInfo(Audioplayer.cover.closest('.w__track--flex'))['top']);

            let offset = (targetPosY === initialPosY) ? 0 : (targetPosY + adjustPosY) - initialPosY;

            // move cover to track being played
            coverSpan.style.transform = (offset > 0)
                ? 'translateY(' + offset + 'px)'
                : 'none';
        }
    }

    static update_scrollPosition()
    {
        if(Audioplayer.playButton)
        {
            Audioplayer.playButton.scrollIntoView({block: 'end', behavior: 'smooth'});
            const elPos = get_elementInfo(Audioplayer.playButton)['top'];

            // adjust offset for track-view
            if(AlbumViewer.active === false)
            {
                if(Audioplayer.playButton.closest('.w__track--variant-ul:not(.active)'))
                {
                    Audioplayer.playButton.closest('.w__track--variant-ul').classList.add('active');
                    Audioplayer.playButton.scrollIntoView({block: 'end', behavior: 'smooth'});
                }

                const scrollPos = window.scrollY || document.documentElement.scrollTop,
                    offsetPos = get_elementInfo(document.getElementById('w--search-bar'))['top'];
                let offsetY = 0;

                if((elPos - offsetPos - 150) < 0)
                {
                    offsetY = elPos - (offsetPos + 150);
                }
                else if(elPos > (myScreen.y - 150))
                {
                    offsetY = elPos - (myScreen.y - 150);
                }

                if(offsetY !== 0)
                {
                    window.scroll(0, scrollPos + offsetY);
                }
            }
        }
    }

    static update_needle(percent)
    {
        if(Audioplayer.needle)
        {
            Audioplayer.needle.style.width = percent + '%';
        }
        Audioplayer.update_time();
    }

    static update_time(seconds)
    {
        if(Audioplayer.controls)
        {
            if(seconds === undefined)
            {
                seconds = Audioplayer.player.currentTime;
            }
            Audioplayer.controls.currentTime.textContent = Audioplayer.rewrite_seconds(seconds);
        }
    }

    // if switching from tracklist to viewer on same album re-assign playButton and update cover position
    static update_source(checkInView)
    {
        const playing = Audioplayer.playing;
        Audioplayer.set_paused(false, checkInView);

        if(AlbumViewer.active === true)
        {
            Audioplayer.playButton = AlbumViewer.container.querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
        }
        else if(myViewer.active === true &&
                myViewer.mode === 'clipboard')
        {
            Audioplayer.playButton = myViewer.container.querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
        }
        else if(document.getElementById('w--tracks'))
        {
            Audioplayer.playButton = document.getElementById('w--tracks')
                .querySelector('.w__track--cmd.play[data-audio-id="' + Audioplayer.audioId + '"]');
        }
        else
        {
            Audioplayer.playButton = undefined;
        }

        if(Audioplayer.playButton)
        {
            if(checkInView)
            {
                Audioplayer.check_inView();
            }
            else if(checkInView !== false)
            {
                Audioplayer.update_scrollPosition();
            }

            if(!playing)
            {
                Audioplayer.cover = Audioplayer.playButton.closest('.w__track--album-ul').querySelector('.w__track--album-cover');
                Audioplayer.update_coverPosition();
            }
        }

        if(playing)
        {
            Audioplayer.set_playing();
        }
    }
}

class Header
{
    static initialize()
    {
        Header.ready = false;
        Header.playing = false;
        Header.activeImg = '';
        Header.lastImg = '';

        if(document.getElementById('w--header'))
        {
            Header.parent = document.getElementById('w--header');
            Header.ready = true;
            Header.activeImg = Header.parent.querySelector('.w__header--img.active');
        }
    }

    static change_image()
    {
        let callAgain = true;

        if(Header.ready === true
           && Header.playing === false
           && Header.parent.querySelectorAll('.w__header--img,.w__lazyload').length > 1)
        {
            let nextImg = Header.activeImg.nextSibling
                            ? Header.activeImg.nextSibling
                            : Header.parent.querySelector('.w__header--img,.w__lazyload');

            while(nextImg.dataset.delete === "1")
            {
                const remImg = nextImg;
                nextImg = nextImg.nextSibling
                            ? nextImg.nextSibling
                            : Header.parent.querySelector('.w__header--img,.w__lazyload');
                remImg.remove();
            }

            if(nextImg !== Header.activeImg)
            {
                if(nextImg.classList.contains('w__lazyload'))
                {
                    callAgain = false;
                    Header.load_image(nextImg);
                }
                else
                {
                    nextImg.classList.add('active');
                    Header.activeImg.classList.remove('active');
                    Header.activeImg = nextImg;
                }
            }
        }

        if(callAgain === true)
        {
            setTimeout(Header.change_image,7500);
        }
    }

    static load_image(nextImg)
    {
        const newImg = new Image();
        newImg.src = adjust_imagePath(nextImg.href);
        newImg.alt = '';
        newImg.classList.add('w__header--img');
        newImg.onload = () =>
        {
            nextImg.insertAdjacentElement('afterend', newImg);
            nextImg.remove();
            newImg.offsetHeight;
            newImg.classList.add('active');
            Header.activeImg.classList.remove('active');
            Header.lastImg = Header.activeImg;
            Header.activeImg = newImg;
            setTimeout(Header.change_image,7500);
        };
    }

    static replace_images(newImages)
    {
        const myElements = Header.parent.querySelectorAll('.w__header--img:not(.w__header--wav),.w__lazyload');
        for(let i=0; i<myElements.length; i++)
        {
            if(myElements[i] !== (Header.activeImg || Header.lastImg) ||
               Audioplayer.playing === true)
            {
                myElements[i].remove();
            }
            else
            {
                myElements[i].dataset.delete = "1";
            }
        }
        for(let i=0; i<newImages.length; i++)
        {
            let newEl;
            if(i === 0 &&
               Audioplayer.playing === true)
            {
                newEl = create('img', {className: 'w__header--img active'});
                newEl.src = adjust_imagePath(newImages[i]);
                Header.activeImg = newEl;
            }
            else
            {
                newEl = create('a', {className: 'w__lazyload'});
                newEl.href = newImages[i];
                newEl.classList.add('w__lazyload');
            }
            Header.parent.appendChild(newEl);
        }
    }
}

class Viewer
{
    constructor(mode)
    {
        this.set_vars(mode);
    }

    set_vars(mode)
    {
        this.active = false;
        this.container = null;
        this.mode = mode;
        this.albumId = 0;
        this.albumCode = 0;
        this.rememberUrl = null;
        this.rememberPageTitle = null;
        this.trackVariants = true;
        this.fromHistory = false;
        this.playlistId = 0;
        this.playlistHash = '';
    }

    adopt_existingViewer(div)
    {
        this.container = div;
        this.active = true;
        this.mode = this.container.dataset.mode;
        this.rememberUrl = '/' + lang + '/';
        this.rememberPageTitle = 'Ring Musik';
        switch(this.mode)
        {
            case 'album':
                this.trackVariants = true;
                this.albumId = this.container.dataset.albumId;
                this.albumCode = this.container.dataset.albumCode;
                this.adjustView_album();
                break;

            case 'clipboard':
                this.playlistId = this.container.dataset.playlistId;
                this.playlistHash = this.container.dataset.playlistHash;
                this.adjustView_clipboard();
                break;

            case 'login':
                this.adjustView();
                break;
        }
        this.add_events();
    }

    add_events()
    {
        // add close() to close button
        const myCloseButton = this.container.querySelector('.w__viewer--close');
        if(myCloseButton)
        {
            myCloseButton.addEventListener('click', this.close.bind(this));
        }

        // add scroll event depending on viewer mode
        if(this.mode === 'album' ||
           this.mode === 'clipboard')
        {
                let myScrollTimer;
                this.container.addEventListener('scroll', () =>
                {
                    cancelAnimationFrame(myScrollTimer);
                    myScrollTimer = requestAnimationFrame(do_onScroll);
                }, true);
        }

        // add drag'n'drop events
        if(this.mode === 'clipboard')
        {

        }
    }

    build(html, addClass, fromHistory)
    {
        // remove existing viewer
        if(fromHistory)
        {
            this.fromHistory = fromHistory;
            const oldViewer = document.body.querySelector('.w__viewer');
            if(oldViewer)
            {
                oldViewer.remove();
            }
        }

        this.container = create('article', {className: 'w__viewer out ' + this.mode, html: html, dataset: {mode: this.mode}});
        if(addClass)
        {
            this.container.classList.add(addClass);
        }
        this.add_events();

        document.body.appendChild(this.container);
        this.container.offsetHeight;

        this.open();
    }

    submit_form(el)
    {
        if(this.check_form(el,true))
        {
            let type;

            if(el.classList.contains('change-pw'))
            {
                type = 'change-pw';
            }
            else if(el.classList.contains('delete'))
            {
                type = 'delete';
            }
            else if(el.classList.contains('login'))
            {
                type = 'login';
            }
            else if(el.classList.contains('profile'))
            {
                type = 'profile';
            }
            else if(el.classList.contains('register'))
            {
                type = 'register';
            }
            else if(el.classList.contains('reset'))
            {
                type = 'reset';
            }
            else if(el.classList.contains('set-password'))
            {
                type = 'set-password';
            }

            if(type)
            {
                Load.do_request({f: 'form', type: type, data: this.get_formData(el)},false, el);
            }
        }
    }

    get_formData(el)
    {
        const allFields = el.querySelectorAll('input:not([type="submit"])'),
              formData = {};

        for(let i=0; i<allFields.length; i++)
        {
            formData[allFields[i].name] = (allFields[i].type === 'checkbox')
                ? (allFields[i].checked ? allFields[i].value.trim() : 0)
                : allFields[i].value.trim();
        }

        return formData;
    }

    check_form(el, markFields)
    {
        const requiredFields = el.querySelectorAll('input[required]'),
              submitButton = el.querySelector('input[type="submit"]');
        let formOk = true,
            myLabel,
            inputOk;

        for(let i=0; i<requiredFields.length; i++)
        {
            inputOk = false;
            myLabel = requiredFields[i].closest('p').querySelector('.w__viewer--input-label');

            switch(requiredFields[i].type)
            {


                case 'checkbox':

                    if(requiredFields[i].checked)
                    {
                        inputOk = true;
                    }
                    break;

                case 'email':
                    if(do_emailCheck(requiredFields[i].value.trim()))
                    {
                        inputOk = true;
                    }
                    break;

                case 'password':
                    if(requiredFields[i].value.trim().length >= 8 &&
                       requiredFields[i].value.trim().match(/[a-z]/) &&
                       requiredFields[i].value.trim().match(/[A-Z]/) &&
                       requiredFields[i].value.trim().match(/[0-9]/))
                    {
                        inputOk = true;
                    }
                    break;

                default:
                    if(requiredFields[i].value.trim().length >= 2)
                    {
                        inputOk = true;
                    }
            }

            if(inputOk === true)
            {
                if(myLabel)
                {
                    myLabel.classList.remove('w__error');
                }
            }
            else
            {
                if(markFields === true &&
                   myLabel)
                {
                    myLabel.classList.add('w__error');
                }
                formOk = false;
            }
        }

        if(formOk)
        {
            submitButton.classList.add('active');
        }
        else
        {
            submitButton.classList.remove('active');
        }

        return formOk;
    }

    start(p)
    {
        if(this.active === false)
        {
            this.rememberUrl = document.location.pathname;
            this.rememberPageTitle = document.title;

            switch(this.mode)
            {
                case 'album':
                    this.albumId = p.albumId;
                    this.albumCode = p.albumCode;
                    this.trackVariants = true;
                    this.album();
                    break;

                case 'clipboard':
                    this.build(p.html);
                    break;

                case 'playlist':
                    this.mode = 'clipboard';
                    this.playlistId = p.playlistId;
                    this.playlistHash = p.playlistHash;
                    Load.do_request({f: 'playlist',
                                             action: 'view',
                                             url: base + lang + '/playlist/' + this.playlistId + '/' + this.playlistHash});
                    break;

                case 'login':
                    this.build(p.html);
                    break;
            }
        }
    }

    album()
    {
        if(this.albumId !== Audioplayer.albumId)
        {
            Audioplayer.stop(true);
        }
        Load.do_request({f: 'album', url: base + lang + '/album/' + this.albumCode});
    }

    open()
    {
        this.container.classList.remove('out');
        this.active = true;

        const scrollPos = window.scrollY || document.documentElement.scrollTop;
        document.body.style.top = (scrollPos * -1).toString() + 'px';
        document.body.classList.add('w__blur');

        switch(this.mode)
        {
            case 'album':
                document.body.classList.add('w__mode--music');
                this.adjustView_album();
                break;

            case 'clipboard':
                document.body.classList.add('w__mode--music');
                this.playlistAvailable = this.container.querySelector('.w__playlist--ul.available');
                this.playlistSelected = '';
                this.playlistSelectedDiv = '';
                this.clipboardTracks = this.container.querySelector('.w__viewer--album-tracks');
                this.adjustView_clipboard();
                this.dragDrop_activate();
                break;

            case 'login':
                document.body.classList.add('w__blur-all');
                this.adjustView();
                break;
        }
    }

    playlist_save(html)
    {
        if(!this.container.querySelector('.w__clipboard--temp-div'))
        {
            const tempDiv = create('div', {className: 'w__clipboard--temp-div', html: html}),
                  albumDiv = this.container.querySelector('.w__viewer--album-tracks');
            if(albumDiv)
            {
                albumDiv.classList.add('w__playlist');
                albumDiv.insertAdjacentElement('afterbegin', tempDiv);
                this.adjustView_clipboard();
            }
        }
    }

    playlist_saveAsPlaylist(myData, r, el)
    {
        this.reset_clipboardSave();

        // remove existing placeholder
        const myPlaceholder = this.playlistAvailable.querySelector('.w__playlist--item.placeholder');
        if(myPlaceholder)
        {
            myPlaceholder.remove();
        }

        // remove existing viewed class
        const myViewed = this.playlistAvailable.querySelector('.w__playlist--item.viewed');
        if(myViewed)
        {
            myViewed.classList.remove('viewed');
        }

        // add new playlist
        const newPlaylist = create('li',{
                className: 'w__playlist--item w__js-button viewed',
                dataset: {
                    f: 'playlist',
                    action: 'load',
                    playlistId: r['id'],
                    playlistHash: r['hash']
                }
            }),
            playlistTitle = create('span',{className: 'w__playlist--item-label', text: myData.data.name}),
            playlistDate = create('span',{className: 'w__playlist--item-date', text: localize_datetime(r['datetime'])});
        newPlaylist.appendChild(playlistTitle);
        newPlaylist.appendChild(playlistDate);
        this.playlistAvailable.insertAdjacentElement('afterbegin', newPlaylist);

        this.playlist_view(r, el);
    }

    playlist_switch(status)
    {
        const myLabel = this.container.querySelector('.w__viewer--taskbar-title.right'),
              myDownloadTxt = document.getElementById('w--download-all-txt'),
              myDownloadCsv = document.getElementById('w--download-all-csv');
        if(status === 'clipboard')
        {
            myLabel.textContent = (lang === 'de') ? 'Merkzettel' : 'Clipboard';
            myLabel.classList.remove('w__orange');
            myDownloadTxt.href = base + lang + '/download/clipboard/txt/0';
            myDownloadCsv.href = base + lang + '/download/clipboard/csv/0';
            this.playlistId = 0;
            this.playlistHash = '';
        }
        else
        {
            myLabel.textContent = 'Playlist';
            myLabel.classList.add('w__orange');
            myDownloadTxt.href = base + lang + '/download/playlist/txt/' + this.playlistId + '/' + this.playlistHash;
            myDownloadCsv.href = base + lang + '/download/playlist/csv/' + this.playlistId + '/' + this.playlistHash;
        }
    }

    adjustView()
    {
        // measure size of viewer divs
        const containerY = get_elementInfo(this.container.querySelector('.w__viewer--standard-div'))['height'],
              columns = this.container.querySelectorAll('.w__viewer--inner-div');
        let adjust = false;

        for(let i=0; i<columns.length; i++)
        {
            if(get_elementInfo(columns[i])['height'] > containerY)
            {
                adjust = true;
            }
        }
        if(adjust === true)
        {
            this.container.querySelector('.w__viewer--standard-div').classList.add('w__inner-scrollbar');
        }
    }

    /**
     * @param autoscroll / needs to be set to false when calling track infos on album to prevent up-scrolling
     */
    adjustView_album(autoscroll)
    {
        // measure size of album-info div and album-tracks div
        const containerY = get_elementInfo(this.container.querySelector('.w__viewer--album-div'))['height'],
              albumInfoY = get_elementInfo(this.container.querySelector('.w__viewer--album-info'))['height'],
              albumTracksY = get_elementInfo(this.container.querySelector('.w__track--album-ul'))['height'];

        if(albumInfoY > containerY)
        {
            this.container.querySelector('.w__viewer--album-div').classList.add('w__inner-scrollbar');
            this.container.querySelector('.w__viewer--album-tracks').classList.remove('w__inner-scrollbar');
        }
        else if(albumTracksY > containerY)
        {
            this.container.querySelector('.w__viewer--album-tracks').classList.add('w__inner-scrollbar');
            this.container.querySelector('.w__viewer--album-div').classList.remove('w__inner-scrollbar');
        }

        if(this.fromHistory)
        {
            this.trackVariants = true;
            this.albumId = this.container.querySelector('.w__track--album-ul').dataset.albumId;
            this.albumCode = this.container.querySelector('.w__track--album-ul').dataset.albumCode;

            if(Audioplayer.playing)
            {
                Audioplayer.active = true;
                if(!Audioplayer.albumId &&
                    Audioplayer.controls &&
                    Audioplayer.controls.cover &&
                    Audioplayer.controls.cover.dataset.albumId)
                {
                    Audioplayer.albumId = Audioplayer.controls.cover.dataset.albumId;
                    Audioplayer.albumCode = Audioplayer.controls.cover.dataset.albumCode;
                }
            }
        }

        // continue playing track from same album but update Audioplayer
        if(this.albumId === Audioplayer.albumId)
        {
            Audioplayer.update_source(autoscroll);
        }
        else
        {
            Audioplayer.start(this.container.querySelector('.w__track--cmd.play'),true);
        }
    }

    adjustView_clipboard()
    {
        // measure size of album-info div and album-tracks div
        const containerY = get_elementInfo(this.container.querySelector('.w__viewer--clipboard-div'))['height'],
              albumInfo = this.container.querySelector('.w__viewer--album-info'),
              albumInfoY = albumInfo ? get_elementInfo(albumInfo)['height'] : 0,
              albumTracksY = get_elementInfo(this.container.querySelector('.w__track--album-ul'))['height'] +
                             get_elementInfo(this.container.querySelector('.w__track--album-ul'))['top'] -
                             get_elementInfo(this.container.querySelector('.w__viewer--album-tracks'))['top'];

        if(albumInfoY > containerY)
        {
            this.container.querySelector('.w__viewer--clipboard-div').classList.add('w__inner-scrollbar');
            this.container.querySelector('.w__viewer--album-tracks').classList.remove('w__inner-scrollbar');
        }
        else if(albumTracksY > containerY)
        {
            this.container.querySelector('.w__viewer--album-tracks').classList.add('w__inner-scrollbar');
            this.container.querySelector('.w__viewer--clipboard-div').classList.remove('w__inner-scrollbar');
        }

        if(!Audioplayer.playing)
        {
            Audioplayer.start(this.container.querySelector('.w__track--cmd.play'),true);
        }
        else
        {
            if(Audioplayer.audioId)
            {
                Audioplayer.active = true;
                Audioplayer.update_source(true);
            }
        }
    }

    /**
     * closes the current viewer and resets all variables
     *
     * @param forced // when clicking logo during viewer mode
     */
    close(forced)
    {
        if(this.active === true &&
           this.container)
        {
            document.documentElement.style.scrollBehavior = 'auto';
            this.active = false;
            this.container.classList.add('out');
            document.body.classList.remove('w__blur');
            document.body.classList.remove('w__blur-all');
            window.scroll(0,parseInt(document.body.style.top) * -1);
            document.documentElement.removeAttribute('style');

            // unset playlist vars
            this.playlistAvailable = undefined;
            this.playlistSelected = undefined;
            this.playlistSelectedDiv = undefined;
            this.clipboardTracks = undefined;
            this.playlistId = 0;
            this.playlistHash = '';

            if(forced !== true)
            {
                if(this.fromHistory === true)
                {
                    window.history.forward();
                }
                else
                {
                    Load.push_url(this.rememberUrl, this.rememberPageTitle);
                }
            }

            if(Audioplayer.playing !== true &&
               (this.mode === 'album' ||
                this.mode === 'clipboard'))
            {
                Audioplayer.stop();
            }

            setTimeout(() =>
            {
                if(this.mode === 'album' ||
                   this.mode === 'clipboard')
                {
                    Audioplayer.update_source(true);
                }
                if(this.mode !== 'album')
                {
                    this.mode = '';
                }
                this.container.remove();
                this.set_vars(this.mode);
            },500);
        }
    }

    static close_all()
    {
        if(AlbumViewer.active === true)
        {
            AlbumViewer.close(true);
        }
        else if(myViewer.active === true)
        {
            myViewer.close(true);
        }
        const otherViewer = document.body.querySelector('.w__viewer:not([data-mode="album"])');
        if(otherViewer)
        {
            document.body.classList.remove('w__blur');
            otherViewer.remove();
        }
    }

    playlist_load(r, el)
    {
        // unmark last selected playlist
        const activePlaylist = this.playlistAvailable.querySelector('.w__playlist--item.active');
        if(activePlaylist)
        {
            activePlaylist.classList.remove('active');
        }
        // mark selected playlist
        el.classList.add('active');

        if(!this.playlistSelectedDiv)
        {
            this.playlistSelectedDiv = create('div',{className: 'w__playlist--selected-div'});
            this.playlistAvailable.insertAdjacentElement('afterend', this.playlistSelectedDiv);
        }
        this.playlistSelectedDiv.innerHTML = r['html'];
        this.playlistSelectedDiv.offsetHeight;
        this.playlistSelected = this.playlistSelectedDiv.querySelector('.w__playlist--ul.selected');

        this.playlist_adjust();
    }

    playlist_view(r, el)
    {
        myViewer.container.querySelector('.w__viewer--clipboard-div').scrollTop = 0;
        myViewer.clipboardTracks.innerHTML = r['html'];
        myViewer.playlistId = r['id'];
        myViewer.playlistHash = r['hash'];
        Audioplayer.update_source();
        this.playlist_switch('playlist');

        if(el &&
           el.dataset.f === 'playlist' &&
           el.dataset.action === 'edit')
        {
            const activeTrack = this.playlistAvailable.querySelector('.w__playlist--item[data-playlist-id="' + el.dataset.playlistId + '"]'),
                  viewedTrack = this.playlistAvailable.querySelector('.w__playlist--item.viewed');
            if(viewedTrack)
            {
                viewedTrack.classList.remove('viewed');
            }
            if(activeTrack)
            {
                activeTrack.classList.remove('active');
                activeTrack.classList.add('viewed');
            }
            this.playlistSelectedDiv.remove();
            this.playlistSelectedDiv = '';
        }
        myViewer.offsetHeight;
        this.adjustView_clipboard();
        do_onScroll(true);
    }

    playlist_adjust()
    {
        if(this.playlistSelectedDiv)
        {
            // determine height of playlist tracklist
            let targetHeight = (Math.round(get_elementInfo(this.container)['height']) - 320);
            const playlistDescription = this.playlistSelectedDiv.querySelector('.w__playlist--selected-description');
            if(playlistDescription)
            {
                targetHeight -= get_elementInfo(playlistDescription)['height'];
            }
            this.playlistSelected.style.flexBasis = targetHeight.toString() + 'px';
        }
    }

    playlist_empty(html)
    {
        const markedButtons = document.body.querySelectorAll('.w__track--cmd.clipboard.selected');
        for(let i=0; i<markedButtons.length; i++)
        {
            markedButtons[i].classList.remove('selected');
        }
        const trackList = myViewer.container.querySelector('.w__track--album-ul');
        if(trackList && html)
        {
            trackList.innerHTML = '';
            const msg = create('li', {className: 'temp', text: html});
            trackList.appendChild(msg);
        }
    }

    playlist_updateList(el)
    {
        const markedButton = document.body.querySelector('.w__track--cmd.clipboard.selected[data-track-id="' +
                             el.dataset.trackId + '"]');
        if(Audioplayer.audioId === el.closest('.w__track').querySelector('.w__track--cmd.play').dataset.audioId)
        {
            if(Audioplayer.playing === true)
            {
                if(!Audioplayer.play_next())
                {
                    Audioplayer.play_previous();
                }
            }
            else
            {
                Audioplayer.start(myViewer.container.querySelector('.w__track--cmd.play'),true);
            }
        }
        if(markedButton)
        {
            markedButton.classList.remove('selected');
        }
        el.closest('.w__track').remove();
        Audioplayer.update_coverPosition();
    }

    playlist_updateViewed(field, value)
    {
        const viewedTrack = this.playlistAvailable.querySelector('.w__playlist--item.viewed');
        if(viewedTrack)
        {
            if(field === 'label')
            {
                viewedTrack.querySelector('.w__playlist--item-label').textContent = value;
            }
            else if(field === 'description')
            {
                viewedTrack.title = value;
            }
        }
    }

    playlist_isActive()
    {
        return !!(parseInt(this.playlistId) > 0 &&
                  this.playlistHash &&
                  this.playlistHash.match(/^[0-9a-z]{32}$/));
    }

    reset_clipboardSave()
    {
        const tempDiv = this.container.querySelector('.w__clipboard--temp-div'),
              albumTracksDiv = this.container.querySelector('.w__viewer--album-tracks.w__playlist'),
              saveButton = this.container.querySelector('.w__icon--cmd[data-f="clipboard"][data-action="show-save-form"]');

        if(tempDiv)
        {
            tempDiv.remove();
        }

        if(albumTracksDiv)
        {
            albumTracksDiv.classList.remove('w__playlist');
        }

        if(saveButton)
        {
            saveButton.classList.remove('active');
        }

    }

    dragDrop_activate()
    {
        this.remDropTarget = '';
        this.container.addEventListener('dragstart', this.dragDrop_start.bind(this));
        this.container.addEventListener('dragover', this.dragDrop_over.bind(this));
        this.container.addEventListener('drop', this.dragDrop_drop.bind(this));
        this.container.addEventListener('dragend', this.dragDrop_end.bind(this));
    }

    dragDrop_start(e)
    {
        this.dragEl = e.target;
        this.dragParent = this.dragEl.closest('.w__dnd--ul');
        this.dragElIndex = this.get_childIndex(this.dragParent,this.dragEl);
        this.dropOk = false;

        if(this.dragEl.closest('.w__dnd'))
        {
            this.dragEl = this.dragEl.closest('.w__dnd');
        }

        if(this.dragEl.classList.contains('w__dnd'))
        {
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/plain', '');
            this.dragEl.classList.add('w__dnd--being-dragged');
        }
    }

    dragDrop_over(e)
    {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';

        let dropTarget = e.target;

        const dropParent = dropTarget.closest('.w__dnd--ul');

        if(dropTarget.closest('.w__dnd'))
        {
            dropTarget = dropTarget.closest('.w__dnd');
        }

        if(dropParent &&
           dropTarget &&
          (dropTarget.classList.contains('w__dnd') || dropTarget.classList.contains('w__dnd--placeholder')) &&
           dropTarget !== this.remDropTarget &&
           dropTarget !== this.dragEl &&
          (dropParent === this.dragParent ||
          !dropParent.querySelector('.w__dnd:not(.w__dnd--being-dragged)[data-track-id="' + this.dragEl.dataset.trackId + '"]')))
        {
            dropTarget.insertAdjacentElement('beforebegin', this.dragEl);
            this.remDropTarget = dropTarget;
            this.dropOk = true;
        }
    }

    dragDrop_drop(e)
    {
        if(this.dropOk === true)
        {
            let dropTarget = e.target;
            const dropParent = dropTarget.closest('.w__dnd--ul'),
                myData = {trackIds: this.get_trackIds(dropParent)};

            if(dropTarget.closest('.w__dnd'))
            {
                dropTarget = dropTarget.closest('.w__dnd');
            }

            // just reorder
            if(dropParent === this.dragParent)
            {
                if(this.dragElIndex !== this.get_childIndex(dropParent, dropTarget))
                {
                    myData.action = 'order';

                    if(dropParent.dataset.playlistId && dropParent.dataset.playlistHash)
                    {
                        myData.f = 'playlist';
                        myData.playlistId = dropParent.dataset.playlistId;
                        myData.playlistHash = dropParent.dataset.playlistHash;
                    }else if(dropParent.classList.contains('w__track--album-ul'))
                    {
                        myData.f = 'clipboard';
                    }

                    Load.do_request(myData);
                }
            }else
            {
                if(dropParent.classList.contains('w__playlist--ul'))
                {
                    myData.newTrackType = 'simple';
                    this.dragEl.className = 'w__playlist--track w__dnd';
                    this.dragEl.dataset.note = this.dragEl.querySelector('.w__track--description-note').value.trim();
                    const trackTitle = create('span', {
                            className: 'w__playlist--track-title',
                            text: this.dragEl.querySelector('.w__track--title').textContent
                        }),
                        trackVersion = create('span', {
                            className: 'w__playlist--track-version',
                            text: this.dragEl.querySelector('.w__track--version').textContent
                        });
                    this.dragEl.innerHTML = '';
                    this.dragEl.appendChild(trackTitle);
                    this.dragEl.appendChild(trackVersion);
                }else
                {
                    myData.newTrackType = 'complex';
                }

                // drag source parent
                if(this.dragParent.dataset.playlistId && this.dragParent.dataset.playlistHash)
                {
                    myData.sourceType = 'playlist';
                    myData.sourcePlaylistId = this.dragParent.dataset.playlistId;
                    myData.sourcePlaylistHash = this.dragParent.dataset.playlistHash;
                }else
                {
                    myData.sourceType = 'clipboard';
                }

                // drop target parent
                if(dropParent.dataset.playlistId && dropParent.dataset.playlistHash)
                {
                    myData.targetType = 'playlist';
                    myData.targetPlaylistId = dropParent.dataset.playlistId;
                    myData.targetPlaylistHash = dropParent.dataset.playlistHash;
                }else if(dropParent.classList.contains('w__track--album-ul'))
                {
                    myData.targetType = 'clipboard';
                }

                myData.f = 'drag-and-drop';
                myData.trackId = this.dragEl.dataset.trackId;
                myData.trackNote = this.dragEl.dataset.note;
                myData.trackDate = this.dragEl.dataset['datetime'];

                Load.do_request(myData, false, this.dragEl);
            }
        }
    }

    dragDrop_end(e)
    {
        e.target.classList.remove('w__dnd--being-dragged');
        this.remDropTarget = '';
    }

    get_trackIds(ul)
    {
        const tracks = ul.querySelectorAll('.w__dnd'),
              trackIds = [];

        for(let i=0; i<tracks.length; i++)
        {
            trackIds[i] = tracks[i].dataset.trackId;
        }

        return trackIds;
    }

    get_childIndex(parent, child)
    {
        const myChildren = parent.querySelectorAll('.w__dnd');
        for(let i=0; i<myChildren.length; i++)
        {
            if(myChildren[i] === child)
            {
                return i;
            }
        }
    }
}

const animate = function(startEl, endEl, parentEl, color, myFunction, aniDuration)
{
    const startPos = startEl.getBoundingClientRect(),
          endPos = endEl.getBoundingClientRect();
    let animatedEl;

    if(startEl.classList.contains('w__input'))
    {
        animatedEl = document.createElement('li');
        animatedEl.classList.add('w__filter--option');
        animatedEl.textContent = parseInt(startEl.value).toString();
    }
    else
    {
        animatedEl = startEl.cloneNode(true);
    }

    // prepare animated element
    animatedEl.classList.add('clone');
    animatedEl.style.left = startPos.left + 'px';
    animatedEl.style.top = startPos.top + 'px';
    animatedEl.style.position = 'fixed';
    animatedEl.style.zIndex = '9999';
    parentEl.appendChild(animatedEl);
    animatedEl.offsetHeight;

    // do animation
    animatedEl.style.left = endPos.left + 'px';

    switch(color)
    {
        case 'orange':
            animatedEl.style.color = '#ED8B3E';
            animatedEl.style.top = endPos.bottom + 'px';
            break;

        case 'blue':
            animatedEl.style.color = '#05529F';
            animatedEl.style.top = endPos.top + 'px';
            break;

        default:
            animatedEl.style.top = endPos.bottom + 'px';
    }

    if(myFunction)
    {
        if(!aniDuration)
        {
            aniDuration = 250;
        }

        setTimeout(() => {
            animatedEl.remove();
            myFunction();
        }, aniDuration);
    }

    return animatedEl;
};

const create = function(tag, cfg)
{
    const el = document.createElement(tag);
    if(cfg.className)
    {
        el.className = cfg.className;
    }
    if(cfg.id)
    {
        el.id = cfg.id;
    }
    if(cfg.html)
    {
        el.innerHTML = cfg.html;
    }
    if(cfg.text)
    {
        el.textContent = cfg.text;
    }
    if(cfg.dataset)
    {
        Object.getOwnPropertyNames(cfg.dataset).forEach(key =>
        {
            el.dataset[key] = cfg.dataset[key];
        });
    }
    return el;
};

const get_location = function()
{
    if(navigator.geolocation)
    {
        navigator.geolocation.getCurrentPosition(
            myPosition => {
                Load.do_request({f: 'location', latitude: myPosition.coords.latitude, longitude: myPosition.coords.longitude});
            },
            () => {
                Load.do_request({f: 'location', latitude: 0, longitude: 0});
            }
        );
    }
    else
    {
        Load.do_request({f: 'location', latitude: 0, longitude: 0});
    }
};

const get_elementInfo = function(el)
{
    return el.getBoundingClientRect(document.body);
};

const adjust_imagePath = function(imgSrc)
{
    let sizeX = myScreen.x,
        targetPath = '';

    // Header images
    if(imgSrc.match(/\/header\/1920x330\//))
    {
        if(myScreen.highDpi > 1)
        {
            sizeX *= 1.5;
        }
        if(sizeX <= 640)
        {
            targetPath = '640x110';
        }
        else if(sizeX <= 1024)
        {
            targetPath = '1024x176';
        }
        else if(sizeX <= 1472)
        {
            targetPath = '1472x253';
        }
        else if(sizeX <= 1920)
        {
            targetPath = '1920x330';
        }
        else
        {
            targetPath = '2560x440';
        }
        imgSrc = imgSrc.replace('/header/1920x330/', '/header/' + targetPath + '/');
    }
    return imgSrc;
};

const set_mobileMenu = function(active)
{
    const myButton = document.getElementById('w--mobile-menu-button'),
          myMenu = document.getElementById('w--menu');

    if(myBrowser.mobile === true &&
       myButton &&
       myMenu)
    {
        // set inactive
        if(active === true)
        {
            myButton.classList.remove('active');
            myMenu.classList.remove('active');
            document.body.classList.remove('w__blur');
            document.body.classList.remove('w__blur-all');
        }
        // set active
        else
        {
            myButton.classList.add('active');
            myMenu.classList.add('active');
            document.body.classList.add('w__blur');
            document.body.classList.add('w__blur-all');
        }
    }
};

// Measures and stores various screen parameters
const get_screenSize = function()
{
    // Pixel density
    myScreen.highDpi = window.devicePixelRatio ? window.devicePixelRatio : 1;
    if(myScreen.highDpi > 2)
    {
        myScreen.highDpi = 2;
    }

    // Screensize
    if(myBrowser.mobile === true)
    {
        myScreen.x = window.innerWidth;
        myScreen.y = window.innerHeight;
    }
    else
    {
        myScreen.x = document.body.clientWidth;
        myScreen.y = window.innerHeight;
    }

    // only for ie11
    Audioplayer.adjust_waveform();

    // adjust playlist window
    if(myViewer && myViewer.active === true)
    {
        if(myViewer.mode === 'clipboard')
        {
            myViewer.adjustView_clipboard();
        }
        else
        {
            myViewer.adjustView();
        }
        myViewer.playlist_adjust();
    }
    else if(AlbumViewer && AlbumViewer.active === true)
    {
        AlbumViewer.adjustView_album();
    }
};

const do_emailCheck = function(email)
{
    const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;
    return reg.test(email.trim());
};

const do_onScroll = function(forceViewer)
{
    if(document.getElementById('w--autoload'))
    {
        const autoloadEl = document.getElementById('w--autoload'),
              autoloadY = autoloadEl.getBoundingClientRect()['top'];
        if(autoloadY < myScreen.y)
        {
            Load.do_request({
                f: 'autoload',
                page: document.body.dataset.function,
                limitStart: autoloadEl.dataset.limitStart
            });
            autoloadEl.remove();
        }
    }

    let tracks;
    if(AlbumViewer.active === true)
    {
        tracks = AlbumViewer.container;
    }
    else if(myViewer.active && myViewer.mode === 'clipboard')
    {
        tracks = myViewer.container;
    }
    else
    {
        tracks = document.getElementById('w--tracks');
    }

    if(tracks && tracks.classList.contains('w__tracks--show-wav'))
    {
        const myWavs = tracks.querySelectorAll('.w__track--waveform.w__lazyload');
        let scaleFactor = 1;

        if(ie11)
        {
            if(forceViewer === true ||
               AlbumViewer.active === true ||
              (myViewer.active === true && myViewer.mode === 'clipboard'))
            {
                tracks = tracks.querySelector('.w__viewer--album-tracks');
            }
            scaleFactor = (parseInt(get_elementInfo(tracks)['width']) - 490) / 1920;
        }

        for(let i=0; i<myWavs.length; i++)
        {
            const wavPosY = myWavs[i].getBoundingClientRect()['top'];
                        if(wavPosY > 0 && wavPosY < myScreen.y)
                        {
                            const newImg = new Image();
                            newImg.src = myWavs[i].href;
                            newImg.classList.add('w__track--waveform');

                            if(ie11)
                            {
                                newImg.style.transform = 'scale(' + scaleFactor + ')';
                            }

                            newImg.onload = () =>
                            {
                                myWavs[i].insertAdjacentElement('afterend', newImg);
                                myWavs[i].remove();
                                newImg.offsetHeight;
                            };
                        }
        }
    }

    if(document.body.classList.contains('w__view--albums') && document.getElementById('w--tracks'))
    {
        const myCovers = document.getElementById('w--tracks').querySelectorAll('.w__track--album-cover[sizes="75px"]');
        for(let i=0; i<myCovers.length; i++)
        {
            myCovers[i].setAttribute('sizes','125px');
        }
    }
};

const localize_datetime = function(myDatetime)
{
    // 2019-12-01 23:12:00
    // 0123456789012345678
    if(lang === 'de')
    {
        myDatetime = myDatetime.substr(8,2) + "." +
                     myDatetime.substr(5,2) + "." +
                     myDatetime.substr(0,4) +
                     myDatetime.substr(10,6);
    }
    else
    {
        myDatetime = myDatetime.substr(0,16);
    }
    return myDatetime;
};

const mark_clipboardButton = function(trackId)
{
    const myButton = document.body.querySelector('.w__track--cmd.clipboard[data-track-id="' + trackId + '"]');
    if(myButton)
    {
        myButton.classList.add('selected');
    }
};

const get_randomInt = function(max)
{
    return Math.floor(Math.random() * Math.floor(max));
};

// polyfill el.remove_filter()
if(!Element.prototype.remove)
{
    Element.prototype.remove = function()
    {
        if(this && this.parentNode)
        {
            this.parentNode.removeChild(this);
        }
    };
}

const get_browser = function()
{
    myBrowser.mobile = false;

    if(navigator.vendor.match(/google/i))
    {
        myBrowser.engine = 'blink';
        myBrowser.version = parseInt(navigator.userAgent.replace(/.*chrome\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.vendor.match(/apple/i))
    {
        myBrowser.engine = 'webkit';
        myBrowser.version = parseFloat(navigator.userAgent.replace(/.*version\/([1-9][0-9]*(\.[1-9])?).*/i,'$1'));
    }
    else if(navigator.userAgent.match(/firefox\//i))
    {
        myBrowser.engine = 'gecko';
        myBrowser.version = parseInt(navigator.userAgent.replace(/.*firefox\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/edge\//i))
    {
        myBrowser.engine = 'edgehtml';
        myBrowser.version = parseInt(navigator.userAgent.replace(/.*edge\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/trident\//i))
    {
        myBrowser.engine = 'trident';
        myBrowser.version = parseInt(navigator.userAgent.replace(/.*trident\/([1-9][0-9]*)\..*/i,'$1')) + 4;
    }

    switch(navigator.platform.toLowerCase())
    {
        case 'win32':
            myBrowser.os = 'windows';
            break;

        case 'macintel':
            // detect iOS on iPadOS/Safari 13
            if(navigator.maxTouchPoints > 1)
            {
                myBrowser.os = 'ios';
                myBrowser.mobile = true;
            }
            else
            {
                myBrowser.os = 'osx';
            }
            break;

        case 'ipad':
        case 'iphone':
            myBrowser.os = 'ios';
            myBrowser.mobile = true;
            break;

        default:
            if(navigator.userAgent.match(/android/i))
            {
                myBrowser.os = 'android';
                myBrowser.mobile = true;
            }
            else if(navigator.platform.match(/linux/i))
            {
                myBrowser.os = 'linux';
            }
    }
};

// polyfill el.matches()
if(!Element.prototype.matches)
{

    // noinspection JSUnresolvedVariable
    Element.prototype.matches = Element.prototype.matchesSelector ||
                               Element.prototype.mozMatchesSelector ||
                               Element.prototype.msMatchesSelector ||
                               Element.prototype.oMatchesSelector ||
                               Element.prototype.webkitMatchesSelector;
}

// polyfill el.closest()
if(!Element.prototype.closest)
{
    // noinspection JSValidateTypes
    Element.prototype.closest = function(selector)
    {
        let el = this,
            found = 0,
            returnEl = false;

        while(found === 0)
        {
            if(el.parentNode && el.parentNode !== document.body)
            {
                el = el.parentNode;
                if(el.nodeType === 1 &&
                   el.matches(selector))
                {
                    found = 1;
                    returnEl = el;
                }
            }
            else
            {
                found = -1;
            }
        }
        return returnEl;
    };
}

window.onpopstate = function(e)
{
    if(e.state !== null)
    {
        //const myUrl = newLoc.split('#');
        //newLoc = myUrl[0];
        if(e.state.v)
        {
            let f;

            if(e.state.v.match(/\/album\/[-0-9a-z]+$/))
            {
                f = 'album';
            }
            else if(e.state.v.match(/\/playlist\/[1-9][0-9]*\/[0-9a-z]{32}$/) ||
                    e.state.v.match(/\/playlist\/rm-[1-9][0-9]*\/[-_0-9a-z]+$/))
            {
                f = 'playlist';
            }
            else
            {
                f = 'nav';
            }

            Load.do_request({f: f, url: e.state.v},true);
        }
    }
};

// window resize detection
if(window.requestAnimationFrame)
{
    window.onresize = function()
    {
        cancelAnimationFrame(resizeTimer);
        resizeTimer = requestAnimationFrame(get_screenSize);
    };

    window.onscroll = function()
    {
        cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(do_onScroll);
    };
}